// Mock data for Blox language website
import { generateApiSidebarItems, generateApiDocsContent, generateInternalsSidebarItems, generateInternalsDocsContent } from './docsLoader';

export const downloads = [
  {
    id: 1,
    platform: 'Windows',
    version: '1.0.5',
    size: '17 MB',
    file: 'BLOX-ESL-SDK-2026-version-1.0.5.zip',
    requirements: 'Windows 10 o superior'
  },
  {
    id: 2,
    platform: 'macOS',
    version: '1.0.5',
    size: '42 MB',
    file: 'blox-interpreter-macos.dmg',
    requirements: 'macOS 10.15 o superior'
  },
  {
    id: 3,
    platform: 'Linux',
    version: '1.0.5',
    size: '38 MB',
    file: 'blox-interpreter-linux-x64.tar.gz',
    requirements: 'Ubuntu 20.04+ / Debian 11+'
  }
];

export const features = [
  {
    id: 1,
    title: 'Host-driven',
    description: 'El host controla el proceso. BLOX se ejecuta solo cuando el host lo llama; nunca toma el control del sistema.',
  },
  {
    id: 2,
    title: 'API C limpia',
    description: 'blox.h expone crear VM, registrar funciones nativas, cargar scripts, ejecutar PRINCIPAL y llamar funciones BLOX.',
  },
  {
    id: 3,
    title: 'Comunicación bidireccional',
    description: 'El host llama funciones BLOX. BLOX llama funciones C registradas por el host. Sin acoplar hardware ni UI.',
  },
  {
    id: 4,
    title: 'Datos como TABLA / JSON',
    description: 'Los valores viajan como números, booleanos, strings, TABLAS, vectores, matrices y JSON según el perfil.',
  },
  {
    id: 5,
    title: 'Errores diagnosticables',
    description: 'Los errores vuelven al host como BloxStatus. Un error de script nunca cierra el proceso del host.',
  },
  {
    id: 6,
    title: 'Múltiples perfiles',
    description: 'Core, Core + JSON, ESP32-S3, Godot GDExtension y CLI derivada — el mismo lenguaje en distintos entornos.',
  }
];

export const courses = [
  {
    id: 1,
    title: 'Fundamentos de Blox',
    description: 'Aprende los conceptos básicos del lenguaje desde cero. Ideal para estudiantes y docentes que quieren iniciarse en la programación con un lenguaje 100% en español.',
    price: 150000,
    currency: 'PYG',
    duration: '8 horas',
    level: 'Principiante',
    image: 'https://images.unsplash.com/photo-1516116216624-53e697fedbea?w=800',
    status: 'coming_soon'
  },
  {
    id: 2,
    title: 'Programación Avanzada en Blox',
    description: 'Domina técnicas avanzadas y patrones de diseño. Aprende a usar las APIs premium y desarrollar aplicaciones complejas.',
    price: 250000,
    currency: 'PYG',
    duration: '12 horas',
    level: 'Avanzado',
    image: 'https://images.unsplash.com/photo-1555066931-4365d14bab8c?w=800',
    status: 'coming_soon'
  }
];

export const libraries = [
  {
    id: 1,
    name: 'API de IA - Redes Neuronales',
    description: 'Redes neuronales feed-forward simples con una capa oculta. Basado en el modelo matricial de BLOX. Permite analizar texto, clasificar, generar respuestas y crear bots educativos.',
    price: 100000,
    subscriptionPrice: 20000,
    currency: 'PYG',
    version: '1.0.0',
    category: 'Inteligencia Artificial',
    hasSubscription: true,
    features: [
      'Redes neuronales feed-forward',
      'Entrenamiento con MSE',
      'Clasificación de datos',
      'Bots educativos'
    ],
    codeExample: `IMPRIMIR ("\\nEntrenando red XOR...")
red = neural.entrenar_mse(red1, X, Y, tasa, epocas)
    W1 = red[1].W1
    W2 = red[1].W2
    b1 = red[1].b1
    b2 = red[1].b2`
  },
  {
    id: 2,
    name: 'API Web',
    description: 'Consumir endpoints web, hacer GET/POST, leer JSON e integrarse con APIs del mundo real. Incluye funciones de scraping.',
    price: 100000,
    currency: 'PYG',
    version: '1.0.0',
    category: 'Web & HTTP',
    hasSubscription: false,
    features: [
      'Peticiones GET/POST',
      'Lectura de JSON',
      'Web scraping (HTML a texto)',
      'Integración con APIs externas'
    ],
    codeExample: `direccion = "https://catfact.ninja/fact"
pagina = LEER_WEB(direccion)

// O bien para scraping:
direccion = "https://www.ejemplo.com/"
pagina = HTML_A_TXT(direccion)`
  },
  {
    id: 3,
    name: 'API Estadística / Data',
    description: 'Ideal para escuelas técnicas y universidades. Funciones de media, varianza, regresión, histogramas, gráficos y series temporales.',
    price: 100000,
    currency: 'PYG',
    version: '1.0.0',
    category: 'Estadística',
    hasSubscription: false,
    features: [
      'Media, varianza, desviación',
      'Regresión lineal',
      'Histogramas y gráficos',
      'Series temporales'
    ],
    codeExample: `media = stats.media(datos)
varianza = stats.varianza(datos)
resultado = stats.regresion(X, Y)`
  },
  {
    id: 4,
    name: 'API Avanzadas (Pack Completo)',
    description: 'Acceso a todas las APIs avanzadas: IA/Redes Neuronales, Web/Scraping, Estadística (Markov, Binomial, Poisson) y Gráficos. Incluye programas de ejemplo.',
    price: 300000,
    subscriptionPrice: 50000,
    currency: 'PYG',
    version: '1.0.0',
    category: 'Pack Premium',
    hasSubscription: true,
    isPack: true,
    features: [
      'API de IA - Redes Neuronales',
      'API Web para JSON y scraping',
      'API Estadística (Markov, Binomial, Poisson)',
      'API Gráficos',
      'Programas de ejemplo incluidos'
    ],
    codeExample: `// Incluye todas las APIs premium
INCLUIR "neural.api"
INCLUIR "web.api"
INCLUIR "stats.api"
INCLUIR "graficos.api"`
  }
];

export const docsSections = [
  {
    id: 'intro',
    title: 'Introducción',
    items: [
      { id: 'what-is-blox', title: '¿Qué es Blox?', path: '/docs/intro/what-is-blox' },
      { id: 'installation', title: 'Instalación', path: '/docs/intro/installation' },
      { id: 'first-program', title: 'Primeros Programas', path: '/docs/intro/first-program' }
    ]
  },
  {
    id: 'data-types',
    title: 'Tipos de Datos',
    items: [
      { id: 'basic-types', title: 'Tipos Básicos', path: '/docs/data-types/basic-types' },
      { id: 'vectors-matrices', title: 'Vectores y Matrices', path: '/docs/data-types/vectors-matrices' },
      { id: 'tables', title: 'Tablas y Registros', path: '/docs/data-types/tables' },
      { id: 'databases', title: 'Bases de Datos', path: '/docs/data-types/databases' },
      { id: 'advanced-types', title: 'Tipos Avanzados', path: '/docs/data-types/advanced-types' }
    ]
  },
  {
    id: 'control-flow',
    title: 'Control de Flujo',
    items: [
      { id: 'conditionals', title: 'Estructuras Condicionales', path: '/docs/control-flow/conditionals' },
      { id: 'loops', title: 'Bucles', path: '/docs/control-flow/loops' },
      { id: 'conditional-assignment', title: 'Asignación Condicional', path: '/docs/control-flow/conditional-assignment' }
    ]
  },
  {
    id: 'functions',
    title: 'Funciones',
    items: [
      { id: 'user-functions', title: 'Funciones de Usuario', path: '/docs/functions/user-functions' },
      { id: 'internal-api', title: 'Funciones Internas y API', path: '/docs/functions/internal-api' },
      { id: 'reference', title: 'Referencia Rápida', path: '/docs/functions/reference' }
    ]
  },
  // Funciones internas se cargan dinámicamente desde JSON
  ...generateInternalsSidebarItems(),
  // APIs se cargan dinámicamente desde los JSON
  ...generateApiSidebarItems()
];

export const codeExamples = {
  'hello-world': `FUNCION PRINCIPAL
INICIO "Mi primer programa en Blox"
    IMPRIMIR("¡Hola, Mundo!")
    
    STRING nombre
    NUMERICO version
    
    nombre = "Blox"
    version = 1.0
    
    IMPRIMIR("Bienvenido a " + nombre + " v" + version)
FINAL`,
  'functions': `FUNCION suma_cuadrados(x, y)
FUNCION saludo(nombre)

FUNCION PRINCIPAL
INICIO
    NUMERICO a, b, res
    STRING saludo_final
    
    a = 8
    b = 3
    res = suma_cuadrados(a, b)
    IMPRIMIR("La suma de los cuadrados es: ", res)
    
    saludo_final = saludo("Desarrollador")
    IMPRIMIR(saludo_final)
FINAL

FUNCION suma_cuadrados(x, y)
INICIO
    RETORNAR x * x + y * y
FINAL_FUNCION

FUNCION saludo(nombre)
INICIO
    RETORNAR "¡Hola, " + nombre + "!"
FINAL_FUNCION`,
  'loops': `FUNCION PRINCIPAL
INICIO "Ejemplo de bucles"
    NUMERICO contador, i
    
    // Bucle MIENTRAS
    contador = 0
    MIENTRAS (contador < 5) HACER
        IMPRIMIR("Contador: ", contador)
        contador = contador + 1
    FIN_MIENTRAS
    
    // Bucle PARA
    PARA i = 1 HASTA 5 PASO 1 HACER
        IMPRIMIR("Iteración: ", i)
    FIN_PARA
FINAL`,
  'conditionals': `FUNCION PRINCIPAL
INICIO "Condicionales en Blox"
    NUMERICO edad
    LOGICO mayor_edad
    
    edad = 18
    mayor_edad = edad >= 18
    
    SI (mayor_edad) ENTONCES
        IMPRIMIR("Eres mayor de edad")
    SINO
        IMPRIMIR("Eres menor de edad")
    FIN_SI
    
    // Estructura SEGUN
    NUMERICO dia
    dia = 1
    
    SEGUN
        CUANDO (dia == 1)
            IMPRIMIR("Lunes - Inicio de semana")
        CUANDO (dia == 5)
            IMPRIMIR("Viernes - Fin de semana cerca")
        OTRO
            IMPRIMIR("Otro día de la semana")
    FIN_SEGUN
FINAL`
};

export const docsContent = {
  'what-is-blox': {
    title: '¿Qué es Blox?',
    content: `# ¡Bienvenido a BLOX ESL!

BLOX ESL es un lenguaje de scripting embebible creado para agregar reglas, lógica y automatización a aplicaciones nativas de forma clara, simple y modificable.

Su producto principal es **BLOX Core**: una VM liviana con API C que puede integrarse dentro de programas C/C++, motores como Godot, servicios, simuladores industriales o firmware ESP32-S3. El host mantiene el control del sistema; BLOX aporta la lógica que puede cambiar sin recompilar toda la aplicación.

También existe **BLOX CLI**, una herramienta derivada del Core que permite ejecutar, probar y depurar scripts \`.blox\` desde la terminal.

## ¿Qué es BLOX?

BLOX es un lenguaje de programación y scripting con sintaxis en español, pensado para escribir reglas, algoritmos, automatizaciones y comportamiento embebible de manera legible.

Permite trabajar con funciones definidas por el usuario, estructuras de control, vectores, matrices, tablas, cadenas de texto, recursividad, operaciones matemáticas, procesamiento de datos y comunicación mediante sockets TCP/IP.

En modo embebido, una aplicación host puede crear una VM BLOX, registrar funciones nativas en C, cargar scripts \`.blox\`, ejecutar \`FUNCION PRINCIPAL\` y llamar funciones del script cuando necesita una decisión. A su vez, BLOX puede llamar funciones C registradas por el host para emitir eventos, solicitar acciones o integrarse con hardware, red, archivos, UI o servicios externos.

## BLOX Core y BLOX CLI

BLOX Core es el corazón del proyecto: la biblioteca embebible que permite incorporar BLOX dentro de otros sistemas.

BLOX CLI usa el mismo lenguaje y runtime, pero lo ejecuta desde la línea de comandos. Es ideal para aprender, probar scripts, validar reglas y desarrollar lógica antes de integrarla en una aplicación real.

## Historia

BLOX fue creado originalmente en lenguaje C durante el primer semestre de 1993 como herramienta de apoyo para las materias de Algoritmos I y Compiladores en una Universidad Católica de Paraguay. Parte de su código también sirvió como base para el programa IOPI - Instrucciones de Operación del Sistema Interligado, desarrollado por Itaipu Binacional en 1994.

La versión actual fue renovada para adaptarse a entornos modernos: Windows, Linux, macOS, Godot y ESP32-S3. BLOX ya no es solo una herramienta educativa o de consola; es un lenguaje embebible preparado para integrarse en aplicaciones reales.

## Filosofía de BLOX

BLOX nace del deseo de hacer que la lógica de programación sea clara, accesible y expresiva, especialmente para hispanohablantes.

Su filosofía es la de un **lenguaje puente**: conecta la claridad del español con la potencia de un runtime embebible. Permite aprender, experimentar y automatizar, pero también separar la lógica cambiante del código nativo estable.

En BLOX, el host controla el mundo real. BLOX decide la lógica.

## Ventajas de BLOX

### Embebible por diseño
BLOX Core puede integrarse dentro de hosts C/C++, motores, servicios, simuladores y firmware. No reemplaza al host: lo complementa.

### Sintaxis clara y cercana
Los programas BLOX se leen con una estructura próxima al español, facilitando la comprensión de reglas, algoritmos y flujos de decisión.

### Interoperabilidad con C
El host puede llamar funciones BLOX, y BLOX puede llamar funciones C registradas por el host. Esto permite una integración limpia entre lógica flexible y sistemas nativos.

### Datos estructurados
BLOX trabaja con números, booleanos, strings, vectores, matrices y tablas. En el perfil Core + JSON, también permite intercambio entre tablas y JSON.

### CLI para desarrollo
BLOX CLI permite ejecutar scripts desde terminal, probar reglas rápidamente y validar comportamiento antes de embeberlo en una aplicación.

### Aprendizaje progresivo
BLOX permite comenzar con programas simples y avanzar hacia scripts embebidos, reglas de negocio, simulaciones, automatización, lógica de videojuegos o procesamiento industrial.`,
  },
  'installation': {
    title: 'Instalación y Configuración',
    content: `# Instalación y Configuración

BLOX se distribuye en paquetes separados según el uso:

- **BLOX Core**: biblioteca embebible para integrar BLOX dentro de aplicaciones C/C++, servicios, motores o firmware.
- **BLOX Core + JSON**: variante del Core con soporte para intercambio entre \`TABLA\` y JSON.
- **BLOX CLI**: herramienta derivada del Core para ejecutar scripts \`.blox\` desde la terminal.
- **BLOX Core ESP32-S3**: componente ESP-IDF precompilado para embeber BLOX en firmware ESP32-S3.

Cada descarga incluye un archivo \`USO_RAPIDO.md\` con instrucciones específicas.

## Requisitos del Sistema

### BLOX CLI para Windows

- Sistema operativo: Windows 10 o 11 recomendado.
- Arquitectura: x86_64.
- Memoria RAM: 128 MB mínimos.
- Almacenamiento: menos de 10 MB.
- Dependencias: incluidas dentro del ZIP de descarga.

### BLOX CLI para Linux

- Sistema operativo: Linux x86_64.
- Compilado para entorno GNU/Linux.
- No requiere instalación compleja: basta con descomprimir y ejecutar el binario.

### BLOX Core para Windows/Linux

Pensado para desarrolladores que quieren embeber BLOX en una aplicación host.

Incluye:

- \`blox.h\`: API pública C.
- \`libblox_core.a\`: biblioteca estática.
- \`blox_core.dll\` o \`libblox_core.so\`: biblioteca dinámica, según plataforma.
- \`libblox_host_json.a\`: variante Core + JSON.
- ejemplos mínimos en C.

### BLOX Core para ESP32-S3

Incluye un componente ESP-IDF precompilado:

\`\`\`text
component/blox/
  include/blox.h
  lib/libblox_esp32.a
  CMakeLists.txt
\`\`\`

No es un firmware listo para flashear. Es el Core embebible para integrarlo en un proyecto ESP-IDF.

## Instalación de BLOX CLI

### Windows

1. Descarga \`blox-cli-windows-x86_64-YYYY-MM-DD.zip\`.
2. Descomprime el ZIP, por ejemplo en:

\`\`\`text
C:\\BLOX\\
\`\`\`

La estructura será similar a:

\`\`\`text
C:\\BLOX\\
  cli\\bin\\blox.exe
  examples\\hello.blox
  manuals\\
  USO_RAPIDO.md
\`\`\`

3. Ejecuta un programa desde CMD o PowerShell:

\`\`\`cmd
cd C:\\BLOX
cli\\bin\\blox.exe examples\\hello.blox
\`\`\`

Para ver la versión:

\`\`\`cmd
cli\\bin\\blox.exe --version
\`\`\`

### Linux

1. Descarga \`blox-cli-linux-x86_64-YYYY-MM-DD.zip\`.
2. Descomprime el ZIP.
3. Da permiso de ejecución si es necesario:

\`\`\`bash
chmod +x cli/bin/blox
\`\`\`

4. Ejecuta un programa:

\`\`\`bash
./cli/bin/blox examples/hello.blox
\`\`\`

## Uso de BLOX Core en C

BLOX Core se usa cuando quieres que una aplicación nativa cargue y ejecute scripts \`.blox\`.

Flujo básico:

1. Crear una VM con \`blox_vm_create()\`.
2. Registrar funciones C con \`blox_vm_register_native()\`.
3. Cargar un script con \`blox_vm_load_file()\`.
4. Ejecutar \`FUNCION PRINCIPAL\` con \`blox_vm_run_main()\`.
5. Llamar funciones BLOX con \`blox_vm_call()\`.
6. Leer resultados mediante \`BloxValue\`, \`TABLA\` o JSON.

Ejemplo conceptual:

\`\`\`c
BloxVM *vm = blox_vm_create();

blox_vm_register_native(
    vm,
    "HOST_LOG",
    1,
    BLOX_VALUE_EMPTY,
    host_log,
    NULL
);

blox_vm_load_file(vm, "programa.blox");
blox_vm_run_main(vm);

BloxValue resultado;
blox_vm_call(vm, "evaluar", NULL, 0, &resultado);

blox_vm_destroy(vm);
\`\`\`

## Configuración con Sublime Text

La integración con Sublime Text aplica principalmente a BLOX CLI, porque permite ejecutar scripts \`.blox\` desde el editor.

### Modo 1: Ventana CMD externa

Crea un archivo \`BLOX_externo.sublime-build\`:

\`\`\`json
{
  "shell_cmd": "start cmd /k \\"cd C:\\\\BLOX && cli\\\\bin\\\\blox.exe '\${file}'\\"",
  "working_dir": "C:\\\\BLOX",
  "selector": "source.blox"
}
\`\`\`

Ventajas:

- Abre una ventana CMD separada.
- Permite interacción por consola.
- La ventana permanece abierta al finalizar.

### Modo 2: Consola integrada

Crea un archivo \`BLOX.sublime-build\`:

\`\`\`json
{
  "cmd": ["C:/BLOX/cli/bin/blox.exe", "$file"],
  "working_dir": "C:/BLOX",
  "selector": "source.blox"
}
\`\`\`

Ventajas:

- No abre ventanas adicionales.
- Muestra la salida dentro de Sublime Text.
- Es cómodo para pruebas rápidas.

Para cambiar entre modos:

**Tools → Build System → BLOX**

## Verificación

Después de descomprimir el paquete CLI, prueba:

\`\`\`cmd
cli\\bin\\blox.exe examples\\hello.blox
\`\`\`

o en Linux:

\`\`\`bash
./cli/bin/blox examples/hello.blox
\`\`\`

Si el programa se ejecuta y muestra salida en consola, BLOX CLI está listo.

Para **BLOX Core**, revisa el archivo \`USO_RAPIDO.md\` incluido en el ZIP correspondiente. Allí se indican los comandos para compilar un host C usando la biblioteca estática o dinámica.`,
  },
  'first-program': {
    title: 'Primeros Programas con BLOX',
    content: `# Primeros programas con BLOX

Este documento muestra los dos primeros pasos prácticos con BLOX ESL:

- ejecutar un script con **BLOX CLI**;
- embeber BLOX dentro de un programa C con **BLOX Core**.

La CLI es la forma más simple de probar el lenguaje desde terminal. BLOX Core es el producto principal: la biblioteca embebible que permite que una aplicación host cargue scripts \`.blox\`, llame funciones BLOX y registre funciones nativas que BLOX puede invocar.

## Tu primer programa CLI: "Hola mundo"

El clásico \`Hola mundo\` sirve para verificar tres cosas:

- que el binario de BLOX CLI funciona;
- que puedes ejecutar un archivo \`.blox\`;
- que entiendes la estructura mínima de un programa BLOX.

### Script BLOX

Crea un archivo llamado \`holamundo.blox\`:

\`\`\`blox
FUNCION PRINCIPAL
INICIO
    IMPRIMIR("Hola mundo")
FINAL
\`\`\`

### Qué significa

\`FUNCION PRINCIPAL\` define el punto de entrada del programa.

\`INICIO\` y \`FINAL\` delimitan el bloque de instrucciones que se ejecuta.

\`IMPRIMIR()\` es una función interna que muestra texto o valores en la consola.

El texto se escribe entre comillas dobles:

\`\`\`blox
"Hola mundo"
\`\`\`

### Ejecutarlo en Windows

Si descomprimiste BLOX CLI en \`C:\\BLOX\`, ejecuta:

\`\`\`bat
cd C:\\BLOX
cli\\bin\\blox.exe holamundo.blox
\`\`\`

También puedes ejecutar el ejemplo incluido en el ZIP:

\`\`\`bat
cli\\bin\\blox.exe examples\\hello.blox
\`\`\`

### Ejecutarlo en Linux

Desde la carpeta donde descomprimiste el ZIP:

\`\`\`bash
chmod +x cli/bin/blox
./cli/bin/blox holamundo.blox
\`\`\`

O ejecuta el ejemplo incluido:

\`\`\`bash
./cli/bin/blox examples/hello.blox
\`\`\`

### Resultado esperado

Verás una salida similar a:

\`\`\`text
Hola mundo
\`\`\`

Según la versión o el modo de ejecución, BLOX también puede mostrar información adicional de finalización, tiempo de ejecución o validación del programa.

## Tu primer programa embebido con BLOX Core

BLOX no está pensado solamente para ejecutarse desde la terminal. Su uso principal es como lenguaje embebible: una aplicación host crea una VM BLOX, carga un script \`.blox\` y le pide decisiones o comportamiento.

En este primer ejemplo, el host está escrito en C.

El host hará tres cosas:

- registrar una función C llamada \`HOST_LOG\`;
- cargar un script BLOX llamado \`programa.blox\`;
- llamar una función BLOX llamada \`sumar()\` y leer su resultado.

A su vez, el script BLOX podrá llamar a la función C registrada.

### Script BLOX

Crea un archivo llamado \`programa.blox\`:

\`\`\`blox
FUNCION sumar()

FUNCION PRINCIPAL
INICIO
    HOST_LOG("script BLOX cargado desde C")
FINAL

FUNCION sumar()
INICIO
    RETORNAR 40 + 2
FINAL_FUNCION
\`\`\`

### Host C

Crea un archivo llamado \`embed_demo.c\`:

\`\`\`c
#include <stdio.h>
#include "blox.h"

static BloxStatus host_log(
    BloxVM *vm,
    const BloxValue *args,
    size_t argc,
    BloxValue *result,
    void *user_data
) {
    (void)vm;
    (void)user_data;

    if (argc != 1 || args[0].type != BLOX_VALUE_STRING) {
        return BLOX_ERROR_INVALID_ARGUMENT;
    }

    printf("BLOX dice: %.*s\\n",
        (int)args[0].as.string.length,
        args[0].as.string.data);

    result->type = BLOX_VALUE_EMPTY;
    return BLOX_OK;
}

int main(void) {
    BloxVM *vm = blox_vm_create();
    BloxValue result;

    if (!vm) {
        return 1;
    }

    blox_vm_register_native(
        vm,
        "HOST_LOG",
        1,
        BLOX_VALUE_EMPTY,
        host_log,
        NULL
    );

    blox_vm_load_file(vm, "programa.blox");
    blox_vm_run_main(vm);
    blox_vm_call(vm, "sumar", NULL, 0, &result);

    if (result.type == BLOX_VALUE_NUMBER) {
        printf("resultado = %.0f\\n", result.as.number);
    }

    blox_vm_destroy(vm);
    return 0;
}
\`\`\`

### Qué está pasando

El programa C crea una VM:

\`\`\`c
BloxVM *vm = blox_vm_create();
\`\`\`

Luego registra una función nativa:

\`\`\`c
blox_vm_register_native(vm, "HOST_LOG", 1, BLOX_VALUE_EMPTY, host_log, NULL);
\`\`\`

Desde ese momento, el script BLOX puede llamar:

\`\`\`blox
HOST_LOG("script BLOX cargado desde C")
\`\`\`

Después, el host carga el script:

\`\`\`c
blox_vm_load_file(vm, "programa.blox");
\`\`\`

Ejecuta \`FUNCION PRINCIPAL\`:

\`\`\`c
blox_vm_run_main(vm);
\`\`\`

Y finalmente llama una función BLOX:

\`\`\`c
blox_vm_call(vm, "sumar", NULL, 0, &result);
\`\`\`

Esto demuestra la comunicación en dos direcciones:

\`\`\`text
C -> llama funciones BLOX
BLOX -> llama funciones C registradas
\`\`\`

### Compilar en Windows

Desde el ZIP de BLOX Core para Windows:

\`\`\`bat
gcc -std=c99 -O2 -DBLOX_USE_SHARED ^
    -Icore\\include ^
    embed_demo.c ^
    -Lcore\\lib -lblox_core ^
    -o embed_demo.exe
\`\`\`

Antes de ejecutar, asegura que \`blox_core.dll\` esté disponible:

\`\`\`bat
set PATH=%CD%\\core\\bin;%PATH%
embed_demo.exe
\`\`\`

### Compilar en Linux

Desde el ZIP de BLOX Core para Linux:

\`\`\`bash
gcc -std=c99 -O2 \\
    -Icore/include \\
    embed_demo.c \\
    -Lcore/lib -lblox_core \\
    -Wl,-rpath,'\$ORIGIN/core/lib' \\
    -o embed_demo
\`\`\`

Ejecuta:

\`\`\`bash
./embed_demo
\`\`\`

### Resultado esperado

\`\`\`text
BLOX dice: script BLOX cargado desde C
resultado = 42
\`\`\`

## Idea principal

Estos dos ejemplos muestran la progresión natural de BLOX:

- con BLOX CLI pruebas scripts \`.blox\` desde terminal;
- con BLOX Core embebes esos scripts dentro de una aplicación real.

El contrato básico de BLOX Core es:

- C crea y controla la VM;
- C registra funciones nativas;
- BLOX puede llamar esas funciones registradas;
- C puede llamar funciones definidas en BLOX;
- BLOX devuelve resultados al host.

En una aplicación real, \`HOST_LOG\` podría ser reemplazada por funciones como:

- \`HOST_ENVIAR_EVENTO\`;
- \`HOST_LEER_SENSOR\`;
- \`HOST_ACTIVAR_RELE\`;
- \`HOST_CREAR_ENTIDAD\`;
- \`HOST_PUBLICAR_MQTT\`.

El patrón es el mismo: **el host controla el sistema, BLOX decide la lógica.**`,
  },

  'basic-types': {
    title: 'Tipos Básicos',
    content: `# Tipos Básicos: \`NUMERICO\`, \`STRING\`, \`LOGICO\`

En BLOX, los tipos básicos son la materia prima del lenguaje.  
Con ellos se construyen expresiones, condiciones, mensajes, estructuras de control y gran parte de los programas cotidianos.

Los tres tipos básicos principales son:

- \`NUMERICO\`
- \`STRING\`
- \`LOGICO\`

Entender bien su comportamiento es clave para escribir programas claros, correctos y fáciles de mantener.

## \`NUMERICO\`

El tipo \`NUMERICO\` representa valores reales, es decir, números que pueden tener parte decimal.

Se usa para:

- cálculos matemáticos
- contadores
- índices numéricos
- fórmulas
- comparaciones
- parámetros de funciones numéricas

## Declaración y uso

\`\`\`blox
NUMERICO a, b, resultado

a = 5.5
b = 2.3
resultado = a + b

IMPRIMIR(resultado)
\`\`\`

## Características

- Soporta suma, resta, multiplicación y división.
- Soporta potencias y operaciones matemáticas habituales.
- Es el tipo natural para casi todo cálculo en BLOX.
- No existe un tipo entero separado: los valores numéricos se manejan como reales.

## Enteros en BLOX

Aunque BLOX no tiene un tipo entero independiente, existe la función \`ENTERO()\` para convertir o truncar un valor numérico según la semántica definida por el lenguaje.

\`\`\`blox
NUMERICO x, n

x = 7.9
n = ENTERO(x)
\`\`\`

## Advertencias

- Evita comparar números reales con \`==\` cuando haya operaciones intermedias de punto flotante.
- En cálculos delicados, conviene usar tolerancias o criterios numéricos adecuados.
- Aunque un valor parezca entero, internamente sigue siendo \`NUMERICO\`.

## Ejemplo típico

\`\`\`blox
NUMERICO radio, area

radio = 5
area = PI * radio^2

IMPRIMIR(area)
\`\`\`

---

## \`STRING\`

El tipo \`STRING\` representa texto.

Se usa para:

- mensajes
- nombres
- rutas de archivos
- datos leídos desde teclado o archivos
- claves dinámicas
- expresiones de texto en general

En BLOX, \`STRING\` puede aparecer en dos formas frecuentes:

- como **string escalar**
- como **vector de strings**

## String escalar

Un string escalar representa una sola cadena de texto.

\`\`\`blox
STRING saludo

saludo = "Hola mundo!"
IMPRIMIR(saludo)
\`\`\`

## Vector de strings

Un vector de strings permite almacenar varias cadenas en una misma variable indexada.

\`\`\`blox
STRING nombres[3]

nombres[1] = "Ana"
nombres[2] = "Luis"
nombres[3] = "Pedro"

IMPRIMIR(nombres[1])
\`\`\`

> **Importante:** Los vectores de \`STRING\` usan índices base 1.

## Características

- Permite concatenación.
- Puede compararse con otras cadenas.
- Distingue mayúsculas de minúsculas.
- Se usa intensamente en funciones como \`SUBSTR()\`, \`LONGITUD()\`, \`REEMPLAZAR()\`, \`COMPARAR()\`, \`IGUAL()\`, \`ORDEN()\`, \`CARACTER()\` y otras del módulo de strings.

## Concatenación

\`\`\`blox
STRING nombre, mensaje

nombre = "Ana"
mensaje = "Hola " + nombre

IMPRIMIR(mensaje)
\`\`\`

Según el caso, también pueden usarse funciones específicas como \`CONCATENAR()\` o \`UNIR()\`.

## Advertencias

- No confundas un \`STRING\` escalar con un vector de strings.
- \`"Ana"\` y \`"ana"\` son textos distintos.
- Si trabajas con listas de texto, conviene recordar que el vector de strings usa índices desde \`1\`.

## Ejemplo típico

\`\`\`blox
STRING nombre, apellido, completo

nombre = "Juan"
apellido = "Perez"
completo = nombre + " " + apellido

IMPRIMIR(completo)
\`\`\`

---

## \`LOGICO\`

El tipo \`LOGICO\` representa valores booleanos.

Sus únicos dos valores posibles son:

- \`VERDADERO\`
- \`FALSO\`

Se usa para:

- condiciones
- decisiones
- validaciones
- banderas de control
- resultados de comparaciones

## Declaración y uso

\`\`\`blox
LOGICO bandera

bandera = VERDADERO

SI (bandera) ENTONCES
    IMPRIMIR("La bandera es: ", bandera)
FIN_SI
\`\`\`

## Negación lógica

El operador \`!\` permite negar un valor lógico.

\`\`\`blox
LOGICO activo

activo = VERDADERO

SI (!activo) ENTONCES
    IMPRIMIR("Inactivo")
SINO
    IMPRIMIR("Activo")
FIN_SI
\`\`\`

## Características

- Solo admite dos estados.
- Puede asignarse de forma directa.
- También puede aparecer como resultado de comparaciones.
- Es central en estructuras como \`SI\`, \`MIENTRAS\`, \`HACER ... MIENTRAS_QUE\` y otras decisiones del programa.

## Ejemplo con comparación

\`\`\`blox
NUMERICO a, b
LOGICO mayor

a = 10
b = 3

mayor = a > b

SI (mayor) ENTONCES
    IMPRIMIR("a es mayor que b")
FIN_SI
\`\`\`

---

## Resumen comparativo

| Tipo | Representa | Ejemplos |
|---|---|---|
| \`NUMERICO\` | Valores reales | \`3\`, \`2.5\`, \`-7.8\` |
| \`STRING\` | Texto | \`"Hola"\`, \`"BLOX"\` |
| \`LOGICO\` | Verdad lógica | \`VERDADERO\`, \`FALSO\` |

## Buenas prácticas

- Usa \`NUMERICO\` para todo cálculo, incluso cuando conceptualmente trabajes con enteros.
- Usa \`STRING\` para texto escalar y vectores de strings cuando necesites listas de texto.
- Usa \`LOGICO\` para expresar intención de control, no como reemplazo informal de números.
- Mantén claro cuándo una variable contiene un solo valor y cuándo contiene una colección.

## Errores frecuentes

### 1. Suponer que existe un tipo entero separado

En BLOX, los cálculos numéricos trabajan sobre \`NUMERICO\`.

### 2. Confundir un \`STRING\` escalar con un vector de strings

\`\`\`blox
STRING nombre
STRING nombres[3]
\`\`\`

Estas dos variables no representan lo mismo.

### 3. Olvidar la base de índices del vector de strings

\`\`\`blox
STRING nombres[3]

nombres[1] = "Ana"
\`\`\`

Aquí el primer elemento es \`nombres[1]\`, no \`nombres[0]\`.

### 4. Usar números para expresar estados lógicos sin necesidad

Cuando una variable representa una condición, suele ser mejor modelarla como \`LOGICO\`.

\`\`\`blox
LOGICO listo
listo = VERDADERO
\`\`\`

en lugar de usar números como sustituto semántico del estado.
`,
  },
  'vectors-matrices': {
    title: 'Vectores y Matrices',
    content: `# Vectores y Matrices

Los **vectores** y las **matrices** son estructuras fundamentales en BLOX para trabajar con colecciones numéricas y datos organizados por posición.

Se usan para:

- almacenar series de valores
- representar listas ordenadas
- modelar tablas numéricas
- trabajar con álgebra lineal
- resolver problemas de estadística, gráficos, física e ingeniería

## Vectores

Un **vector** es una colección unidimensional de elementos del mismo tipo, accesibles por índice.

En BLOX, los vectores se usan principalmente para:

- listas de números
- listas de cadenas
- coordenadas
- series temporales
- resultados intermedios de cálculo

## Declarar vectores

En este documento nos centraremos en **vectores numéricos**.

### Vector numérico

\`\`\`blox
VECTOR xs[5]
\`\`\`

Esto crea un vector numérico de dimensión 5.

## Asignar valores a un vector

### Forma elemento a elemento

\`\`\`blox
VECTOR xs[5]

xs[0] = 10
xs[1] = 20
xs[2] = 30
xs[3] = 40
xs[4] = 50
\`\`\`

### Forma literal

\`\`\`blox
VECTOR xs[5]

xs = [10, 20, 30, 40, 50]
\`\`\`

En BLOX, los vectores usan índices **base 0**.

> **Tip:** Si un vector fue declarado con dimensión \`n\`, sus índices válidos van desde \`0\` hasta \`n - 1\`.

## Leer valores de un vector

\`\`\`blox
VECTOR xs[5]
NUMERICO a

a = xs[2]
\`\`\`

## Recorrer un vector

\`\`\`blox
VECTOR xs[5]
NUMERICO i

PARA i = 0 HASTA xs.dim - 1 HACER
    IMPRIMIR(xs[i])
FIN_PARA
\`\`\`

## Propiedad \`.dim\`

La propiedad \`.dim\` indica la cantidad de elementos del vector.

\`\`\`blox
VECTOR xs[10]
NUMERICO n

n = xs.dim
\`\`\`

## Acceso dinámico y uso típico

Los vectores son especialmente útiles cuando necesitas generar datos punto a punto.

\`\`\`blox
VECTOR xs[5], ys[5]
NUMERICO i

PARA i = 0 HASTA 4 HACER
    xs[i] = i
    ys[i] = xs[i]^2
FIN_PARA
\`\`\`

Esto produce una pequeña serie de pares:

- \`x = 0, y = 0\`
- \`x = 1, y = 1\`
- \`x = 2, y = 4\`
- \`x = 3, y = 9\`
- \`x = 4, y = 16\`

## Funciones frecuentes con vectores

Dependiendo de las APIs incluidas, BLOX puede trabajar con funciones como:

- búsqueda
- ordenamiento
- reversa
- inserción
- eliminación
- concatenación
- impresión

Un patrón muy común es:

\`\`\`blox
INCLUIR "vectores.api"
\`\`\`

y luego usar funciones auxiliares sobre \`VECTOR\`.

## Buenas prácticas con vectores

- Recorre vectores numéricos desde \`0\` hasta \`dim - 1\`.
- Asegúrate de no acceder a posiciones fuera de rango.
- Usa nombres claros como \`xs\`, \`ys\`, \`datos\`, \`valores\`, \`indices\`.
- Si dos vectores representan pares ordenados, mantén siempre la misma dimensión.

## Errores frecuentes con vectores

### 1. Confundir índices base 0 con base 1

Esto es incorrecto para vectores:

\`\`\`blox
PARA i = 1 HASTA xs.dim HACER
    IMPRIMIR(xs[i])
FIN_PARA
\`\`\`

La forma correcta suele ser:

\`\`\`blox
PARA i = 0 HASTA xs.dim - 1 HACER
    IMPRIMIR(xs[i])
FIN_PARA
\`\`\`

### 2. Usar índices fuera de rango

\`\`\`blox
VECTOR xs[5]
xs[5] = 100
\`\`\`

Eso intenta escribir fuera del vector, porque el último índice válido es \`4\`.

### 3. Asumir que todos los contenedores usan la misma base

En BLOX:

- los **vectores** suelen indexarse desde \`0\`
- las **tablas** usan registros desde \`1\`

Conviene no mezclar ambas convenciones.

---

## Matrices

Una **matriz** es una estructura bidimensional de valores numéricos organizada en filas y columnas.

Se usa para:

- álgebra lineal
- sistemas de ecuaciones
- transformaciones geométricas
- procesamiento numérico
- imágenes y convoluciones
- aprendizaje automático

## Declarar matrices

\`\`\`blox
MATRIZ A[3, 4]
\`\`\`

Esto crea una matriz de:

- 3 filas
- 4 columnas

## Acceder a elementos de una matriz

### Sintaxis con coma

\`\`\`blox
MATRIZ A[3, 3]

A[0,0] = 10
A[0,1] = 20
A[1,2] = 50
\`\`\`

### Sintaxis encadenada

\`\`\`blox
MATRIZ A[3, 3]

A[0][0] = 10
A[0][1] = 20
A[1][2] = 50
\`\`\`

En BLOX, las matrices usan índices **base 0**.

> **Tip:** Si una matriz tiene dimensión \`m x n\`, sus índices válidos van desde \`0\` hasta \`m - 1\` en filas, y desde \`0\` hasta \`n - 1\` en columnas.

## Leer valores de una matriz

### Sintaxis con coma

\`\`\`blox
MATRIZ A[3, 3]
NUMERICO x

x = A[1,2]
\`\`\`

### Sintaxis encadenada

\`\`\`blox
MATRIZ A[3, 3]
NUMERICO x

x = A[1][2]
\`\`\`

## Recorrer una matriz

\`\`\`blox
MATRIZ A[3, 3]
NUMERICO i, j

PARA i = 0 HASTA A.filas - 1 HACER
    PARA j = 0 HASTA A.columnas - 1 HACER
        IMPRIMIR(A[i,j])
    FIN_PARA
FIN_PARA
\`\`\`

## Propiedades frecuentes

Según el contexto y las APIs disponibles, una matriz suele trabajarse con:

- cantidad de filas
- cantidad de columnas
- dimensión

Un patrón típico es:

\`\`\`blox
NUMERICO m, n

m = A.filas
n = A.columnas
\`\`\`

## Asignar valores a una matriz

### Forma elemento a elemento

\`\`\`blox
MATRIZ A[2,2]

A[0,0] = 1
A[0,1] = 2
A[1,0] = 3
A[1,1] = 4
\`\`\`

### Forma literal

\`\`\`blox
MATRIZ A[2,2]

A = [[1, 2], [3, 4]]
\`\`\`

## Crear una matriz identidad

\`\`\`blox
MATRIZ I[3,3]
NUMERICO i, j

PARA i = 0 HASTA 2 HACER
    PARA j = 0 HASTA 2 HACER
        SI (i == j) ENTONCES
            I[i,j] = 1
        SINO
            I[i,j] = 0
        FIN_SI
    FIN_PARA
FIN_PARA
\`\`\`

## Operaciones frecuentes con matrices

En BLOX es común trabajar con funciones como:

- suma
- resta
- multiplicación
- transpuesta
- determinante
- inversa
- diagonales
- rotaciones
- convolución

Muchas de estas operaciones viven en:

\`\`\`blox
INCLUIR "matrices.api"
\`\`\`

## Ejemplo simple de carga manual

\`\`\`blox
MATRIZ A[2,2]

A[0,0] = 1
A[0,1] = 2
A[1,0] = 3
A[1,1] = 4
\`\`\`

## Ejemplo conceptual de transpuesta

Si:

$$
A =
\\begin{bmatrix}
1 & 2 \\\\
3 & 4
\\end{bmatrix}
$$

entonces su transpuesta es:

$$
A^T =
\\begin{bmatrix}
1 & 3 \\\\
2 & 4
\\end{bmatrix}
$$

En una transpuesta, filas y columnas se intercambian.

## Ejemplo conceptual de rotación 180°

Rotar una matriz 180° equivale a invertir el orden de sus filas y columnas.

Si:

$$
A =
\\begin{bmatrix}
1 & 2 \\\\
3 & 4
\\end{bmatrix}
$$

entonces:

$$
R_{180}(A) =
\\begin{bmatrix}
4 & 3 \\\\
2 & 1
\\end{bmatrix}
$$

## Filas y columnas

Muchas funciones de matrices trabajan específicamente sobre:

- una fila
- una columna
- la diagonal principal
- la diagonal secundaria

Por ejemplo:

- mínimo en una columna
- máximo en una fila
- suma de una diagonal
- extracción de submatrices

## Matrices y gráficos

Las matrices también pueden servir para:

- representar imágenes en escala de grises
- aplicar filtros
- almacenar kernels de convolución
- describir transformaciones geométricas

## Matrices y redes neuronales

En BLOX, las matrices aparecen con frecuencia en:

- multiplicación entre capas
- suma de bias
- funciones de activación aplicadas elemento a elemento
- propagación hacia adelante

## Buenas prácticas con matrices

- Recorre matrices usando dos índices: fila y columna.
- Recuerda que las matrices en BLOX usan base 0.
- Verifica compatibilidad de dimensiones antes de sumar o multiplicar.
- Usa nombres expresivos como \`A\`, \`B\`, \`W\`, \`X\`, \`Y\`, \`kernel\`.

## Errores frecuentes con matrices

### 1. Confundir los límites válidos

Si una matriz es \`A[3,3]\`, sus índices válidos van de \`0\` a \`2\`.

Esto es incorrecto:

\`\`\`blox
A[3,3] = 1
\`\`\`

Una forma válida sería:

\`\`\`blox
A[2,2] = 1
\`\`\`

### 2. Confundir filas con columnas

En:

\`\`\`blox
A[i,j]
\`\`\`

- \`i\` representa la fila
- \`j\` representa la columna

### 3. Multiplicar matrices incompatibles

Si \`A\` es de dimensión \`m x n\` y \`B\` es de dimensión \`p x q\`, solo puedes calcular \`A * B\` cuando:

$$
n = p
$$

### 4. Mezclar las convenciones de índices

En BLOX conviven varias estructuras:

- \`VECTOR\` suele usar base 0
- \`MATRIZ\` usa base 0
- \`TABLA\` usa registros desde 1

Conviene tener esto muy presente cuando conviertes datos entre unas y otras.

## Ejemplo completo

\`\`\`blox
VECTOR xs[5]
MATRIZ A[2,2]
NUMERICO i

PARA i = 0 HASTA xs.dim - 1 HACER
    xs[i] = i^2
FIN_PARA

// También podría escribirse:
// xs = [0, 1, 4, 9, 16]

A = [[1, 2], [3, 4]]

IMPRIMIR(xs[3])
IMPRIMIR(A[1,0])
IMPRIMIR(A[1][0])
\`\`\`

## Resumen

En BLOX:

- un **vector** es una estructura unidimensional
- una **matriz** es una estructura bidimensional
- los vectores se recorren con índices base 0
- las matrices se recorren con índices base 0

Ambas estructuras son esenciales para:

- cálculo numérico
- estadística
- gráficos
- física
- procesamiento de datos
- inteligencia artificial
`,
  },
  'tables': {
    title: 'Tablas y Registros',
    content: `# Tablas y Registros

Las **tablas** en BLOX son una de las estructuras más potentes y flexibles del lenguaje.  
Permiten representar colecciones de registros, donde cada registro agrupa pares \`campo = valor\`.

Una tabla puede usarse para:

- almacenar datos tipo lista
- representar filas de una planilla
- trabajar con registros heterogéneos
- importar y exportar datos
- buscar, filtrar, mezclar y transformar información

## ¿Qué es una tabla en BLOX?

Una tabla es un conjunto ordenado de **registros**.

Cada registro contiene **campos** con nombre, por ejemplo:

- \`nombre\`
- \`edad\`
- \`ciudad\`

y cada campo puede guardar distintos tipos de dato:

- \`NUMERICO\`
- \`STRING\`
- \`LOGICO\`
- \`VECTOR\`
- \`MATRIZ\`
- \`TABLA\`

\`\`\`blox
TABLA personas

personas = { nombre = "Ana", edad = 28, ciudad = "Asuncion" }
personas = { nombre = "Luis", edad = 35, ciudad = "Encarnacion" }
\`\`\`

En este ejemplo:

- \`personas\` es una tabla
- \`personas[1]\` es el primer registro
- \`personas[2]\` es el segundo registro

> **Tip:** Las tablas se expanden automáticamente a medida que agregas registros. No necesitas definir previamente la cantidad de filas ni los nombres de los campos.

## ¿Qué es un registro?

Un **registro** es una sola fila lógica dentro de una tabla.

\`\`\`blox
TABLA personas

personas = {
    nombre = "Carlos",
    edad = 30,
    ciudad = "Asuncion"
}
\`\`\`

Aquí, \`personas[1]\` es un registro con tres campos:

- \`nombre\`
- \`edad\`
- \`ciudad\`

Puedes imprimirlo directamente:

\`\`\`blox
IMPRIMIR(personas[1])
\`\`\`

## Crear tablas

### Crear una tabla vacía

\`\`\`blox
TABLA personas
\`\`\`

### Agregar registros

\`\`\`blox
TABLA personas

personas = { nombre = "Ana", edad = 28 }
personas = { nombre = "Luis", edad = 35 }
personas = { nombre = "Marta", edad = 22 }
\`\`\`

Cada asignación de este tipo agrega un nuevo registro al final de la tabla.

## Acceso a registros y campos

### Acceso por índice

\`\`\`blox
registro = personas[1]
\`\`\`

### Acceso por nombre de campo

\`\`\`blox
nombre = personas[1].nombre
edad   = personas[1].edad
\`\`\`

### Acceso con corchetes

\`\`\`blox
nombre = personas[1]["nombre"]
edad   = personas[1]["edad"]
\`\`\`

### Acceso dinámico a campos

Esto es útil cuando el nombre del campo está en una variable:

\`\`\`blox
STRING campo, valor

campo = "nombre"
valor = personas[1][campo]
\`\`\`

## Modificar valores

Puedes modificar un campo existente de esta forma:

\`\`\`blox
personas[2].ciudad = "Ciudad del Este"
\`\`\`

o con clave dinámica:

\`\`\`blox
STRING campo

campo = "ciudad"
personas[2][campo] = "Ciudad del Este"
\`\`\`

## Regla importante: creación automática de campos

En BLOX, una asignación como:

\`\`\`blox
tabla[i][campo] = valor
tabla[i].campo = valor
\`\`\`

tiene esta semántica:

- si el campo ya existe, se modifica
- si el campo no existe, se crea automáticamente y luego se asigna el valor

Ejemplo:

\`\`\`blox
TABLA personas

personas = { nombre = "Roberto", ciudad = "Concepcion" }

personas[1].email = "rob@mail.com"
\`\`\`

Resultado:

\`\`\`blox
{
    nombre = "Roberto",
    ciudad = "Concepcion",
    email = "rob@mail.com"
}
\`\`\`

> **Nota importante:** Este comportamiento es parte aceptada del lenguaje. No se considera un error.

## Modo estricto con \`ES_CAMPO()\`

Si no quieres que un campo se cree automáticamente, puedes proteger la asignación con \`ES_CAMPO()\`.

\`\`\`blox
SI (ES_CAMPO(personas[1], "edad")) ENTONCES
    personas[1].edad = 23
SINO
    ERROR("Campo inexistente.")
FIN_SI
\`\`\`

Esto es útil cuando quieres distinguir entre:

- modificar un campo existente
- crear accidentalmente un campo nuevo por error tipográfico

## Tablas heterogéneas

En BLOX, **no todos los registros tienen que tener los mismos campos**.

\`\`\`blox
TABLA personas

personas = { nombre = "Carlos", edad = 30, ciudad = "Asuncion" }
personas = { nombre = "Juan", edad = 21, ciudad = "Encarnacion" }
personas = { nombre = "Roberto", ciudad = "Concepcion", email = "rob@mail.com" }
\`\`\`

Aquí:

- los registros 1 y 2 tienen \`edad\`
- el registro 3 no tiene \`edad\`
- el registro 3 tiene \`email\`
- los demás no tienen \`email\`

Por eso, en tablas heterogéneas conviene usar:

- \`ES_CAMPO(reg, campo)\`
- \`CLAVES(reg)\`
- \`CLAVES_INFO(reg)\`
- \`TIPO_DATO(tabla, campo)\`

## Subtablas

Un campo también puede contener otra tabla.

\`\`\`blox
TABLA personas

personas = {
    nombre = "Juan",
    direccion = {
        ciudad = "Encarnacion",
        barrio = "Centro"
    }
}
\`\`\`

### Acceso a subcampos

\`\`\`blox
ciudad = personas[1].direccion.ciudad
\`\`\`

o también:

\`\`\`blox
ciudad = personas[1]["direccion"]["ciudad"]
\`\`\`

### Modificar subcampos

\`\`\`blox
personas[1].direccion.barrio = "San Roque"
\`\`\`

## Propiedades y métodos frecuentes

### \`.dim\` — cantidad de registros

\`\`\`blox
NUMERICO cantidad

cantidad = personas.dim
\`\`\`

### \`.CLAVES()\` — nombres de campos de un registro

\`\`\`blox
STRING campos[10]

campos = personas[1].CLAVES()
\`\`\`

### \`CLAVES(registro)\`

\`\`\`blox
STRING campos[10]

campos = CLAVES(personas[1])
\`\`\`

### \`CLAVES_INFO(registro)\`

Devuelve una tabla con información más completa sobre los campos del registro:

- nombre
- tipo
- si es subtabla
- nivel

\`\`\`blox
TABLA info

info = CLAVES_INFO(personas[1])
IMPRIMIR(info[1])
\`\`\`

### \`ES_CAMPO(registro, campo)\`

Verifica si un campo existe en ese registro.

\`\`\`blox
SI (ES_CAMPO(personas[1], "email")) ENTONCES
    IMPRIMIR(personas[1].email)
FIN_SI
\`\`\`

### \`TIPO_DATO(tabla, campo)\`

Obtiene el tipo de dato asociado a un campo.

\`\`\`blox
STRING tipo

tipo = TIPO_DATO(personas, "edad")
IMPRIMIR(tipo)
\`\`\`

Valores típicos:

- \`NUMERICO\`
- \`STRING\`
- \`LOGICO\`
- \`TABLA\`
- \`NO_EXISTE\`
- \`DESCONOCIDO\`

## Operaciones frecuentes con tablas

### Agregar un registro

\`\`\`blox
AGREGAR(personas, { nombre = "Santiago", edad = 33 })
\`\`\`

### Agregar un campo a toda la tabla

\`\`\`blox
AGREGAR(personas, "email")
\`\`\`

### Agregar un campo a un solo registro

\`\`\`blox
AGREGAR(personas[2], "telefono")
personas[2].telefono = "555-123"
\`\`\`

### Eliminar un campo de un registro

\`\`\`blox
ELIMINAR(personas[2], "telefono")
\`\`\`

### Eliminar un registro

\`\`\`blox
ELIMINAR(personas[2])
\`\`\`

### Eliminar un registro por índice

\`\`\`blox
ELIMINAR(personas, 2)
\`\`\`

### Vaciar una tabla

\`\`\`blox
ELIMINAR(personas)
\`\`\`

## Ejemplo completo

\`\`\`blox
TABLA personas
STRING campo

personas = {
    nombre = "Carlos",
    edad = 30,
    ciudad = "Asuncion"
}

personas = {
    nombre = "Roberto",
    ciudad = "Concepcion"
}

campo = "email"
personas[2][campo] = "rob@mail.com"

IMPRIMIR(personas[1])
IMPRIMIR(personas[2])
\`\`\`

Salida esperada:

\`\`\`blox
{
    nombre = "Carlos",
    edad = 30,
    ciudad = "Asuncion"
}

{
    nombre = "Roberto",
    ciudad = "Concepcion",
    email = "rob@mail.com"
}
\`\`\`

## Buenas prácticas

- Usa \`ES_CAMPO()\` cuando quieras evitar la creación automática de campos.
- Usa \`CLAVES()\` o \`CLAVES_INFO()\` para explorar registros heterogéneos.
- Usa \`TIPO_DATO()\` cuando una función de tabla deba soportar varios tipos.
- Si trabajas con subtablas, valida primero su existencia antes de acceder a campos internos.
- Si vas a exportar a CSV o JSON, recuerda que no todos los registros tienen por qué compartir exactamente los mismos campos.

## Errores frecuentes

### 1. Confundir \`edad\` con \`Edad\`

Los nombres de campo son sensibles al texto exacto.

\`\`\`blox
personas[1].edad = 21
personas[1].Edad = 23
\`\`\`

Eso crea dos campos distintos:

- \`edad\`
- \`Edad\`

### 2. Asumir que todos los registros tienen todos los campos

Esto puede fallar en tablas heterogéneas:

\`\`\`blox
IMPRIMIR(personas[3].edad)
\`\`\`

Si no estás seguro, protege con:

\`\`\`blox
SI (ES_CAMPO(personas[3], "edad")) ENTONCES
    IMPRIMIR(personas[3].edad)
FIN_SI
\`\`\`

### 3. Confundir la tabla completa con un registro

- \`personas\` es la tabla completa
- \`personas[1]\` es un registro
- \`personas[1].nombre\` es un campo del registro

## Relación con JSON

Las tablas BLOX se parecen mucho a estructuras tipo JSON.

Por eso existen funciones como:

- \`JSON_A_TABLA()\`
- \`TABLA_A_JSON()\`
- \`TABLA_A_STRING()\`
- \`STRING_A_TABLA()\`

Estas funciones permiten convertir entre texto estructurado y tablas BLOX de forma muy natural.

## Persistencia con SQLite

Una \`TABLA\` no solo sirve para trabajar con datos en memoria.  
Tambien puede volverse **persistente** usando SQLite.

Las dos funciones clave son:

- \`sqlite.importar(db, "tabla_destino", tabla)\`
- \`tabla = sqlite.exportar(db, "SELECT ...")\`

Con esto puedes:

- guardar una tabla entre ejecuciones
- recuperar sus registros mas adelante
- consultar los datos con SQL
- combinar BLOX y SQLite en un mismo flujo de trabajo

Ejemplo conceptual:

\`\`\`blox
INCLUIR "sqlite.api"

SQLITE db
TABLA personas, out

personas = { nombre = "Ana", edad = 28 }
personas = { nombre = "Luis", edad = 35 }

db = sqlite.abrir("personas.db")

sqlite.importar(db, "personas", personas)
out = sqlite.exportar(db, "SELECT nombre, edad FROM personas ORDER BY nombre;")

sqlite.cerrar(db)
\`\`\`

Para una explicacion completa del tipo \`SQLITE\` y de la API de base de datos, consulta el documento **Bases de Datos**.
`,
  },
  'advanced-types': {
    title: 'Tipos Avanzados',
    content: `# Estructuras Avanzadas: Sockets y Archivos

BLOX no se limita al cálculo numérico ni a los algoritmos clásicos.  
También incorpora estructuras avanzadas que permiten interactuar con el mundo exterior: **redes** y **archivos**.

Con ellas, un programa BLOX puede:

- comunicarse con otros procesos
- leer y escribir información persistente
- automatizar tareas del sistema
- conectarse a servicios externos
- construir prototipos de herramientas distribuidas

Estas capacidades amplían el lenguaje desde el terreno académico hacia problemas reales de integración, automatización y comunicación.

Ademas, BLOX ya incorpora una capacidad avanzada adicional de persistencia estructurada: **bases de datos SQLite**.

Con el tipo \`SQLITE\` y la API \`sqlite.api\`, un programa puede:

- abrir o crear una base de datos
- ejecutar sentencias SQL
- consultar datos y recibirlos como \`TABLA\`
- persistir tablas planas entre ejecuciones

Para una explicacion completa, consulta el documento **Bases de Datos**.

## Sockets TCP/IP

### Comunicación entre programas

Un **socket** es un extremo de comunicación que permite a dos programas intercambiar datos a través de una red, normalmente usando el protocolo **TCP/IP**.

Gracias a los sockets, BLOX puede actuar como:

- **cliente**, conectándose a otro proceso
- **servidor**, esperando conexiones entrantes

Esto permite construir programas que dialogan en tiempo real con otras aplicaciones, servicios locales o sistemas remotos.

### Declaración y uso básico

\`\`\`blox
SOCKET s

s.ip = "127.0.0.1"
s.port = 5555

CONECTAR(s)
\`\`\`

En este ejemplo:

- \`s.ip\` define la dirección IP destino
- \`s.port\` define el puerto de comunicación
- \`CONECTAR(s)\` intenta establecer la conexión

La variable \`s\` de tipo \`SOCKET\` actúa como una estructura viva de comunicación, capaz de almacenar tanto el estado de la conexión como los datos recibidos.

### Funciones principales de sockets

| Función | Descripción |
|---|---|
| \`CONECTAR(s)\` | Conecta el socket a una IP y puerto determinados |
| \`ESCUCHAR(s)\` | Prepara un socket para recibir conexiones entrantes |
| \`ACEPTAR(s)\` | Acepta una conexión y retorna un nuevo socket conectado |
| \`ENVIAR(s, x)\` | Envía datos a través del socket |
| \`RECIBIR(s)\` | Recibe datos y los deja disponibles en el socket |
| \`DESCONECTAR(s)\` | Cierra la conexión y libera recursos |

### Idea general de uso

En modo cliente, un flujo típico sería:

\`\`\`blox
SOCKET s

s.ip = "127.0.0.1"
s.port = 5555

CONECTAR(s)
ENVIAR(s, "Hola mundo")
RECIBIR(s)
DESCONECTAR(s)
\`\`\`

Con esto, BLOX puede integrarse con servidores, APIs locales, herramientas auxiliares o procesos escritos en otros lenguajes.

---

## Archivos

### Trabajo con información persistente

BLOX también permite manipular archivos de texto de forma sencilla y directa.

Esto hace posible:

- guardar resultados
- cargar configuraciones
- procesar datos externos
- generar reportes
- automatizar tareas de lectura y escritura

En muchos programas, el archivo es la memoria persistente del sistema.  
Mientras las variables viven durante la ejecución, los archivos permiten conservar información más allá del programa.

## Tipo de dato \`ARCHIVO\`

Una variable de tipo \`ARCHIVO\` representa un manejador o referencia a un archivo abierto.

Su valor normalmente se obtiene con la función \`ABRIR()\`.

\`\`\`blox
ARCHIVO f

f = ABRIR("datos.txt", "r")
\`\`\`

Si la apertura se realiza correctamente, \`f\` tendrá un valor válido.  
Si falla, por ejemplo porque el archivo no existe en modo lectura, entonces \`f\` valdrá \`-1\`.

### Modos de apertura

- \`"r"\`: lectura
- \`"w"\`: escritura
- \`"a"\`: agregado al final

#### Significado práctico

- \`"r"\` abre un archivo existente para leerlo
- \`"w"\` crea un archivo nuevo o sobrescribe uno existente
- \`"a"\` conserva el contenido existente y agrega nuevas líneas al final

## Funciones principales de archivos

| Función | Descripción | Ejemplo |
|---|---|---|
| \`ABRIR()\` | Abre un archivo | \`f = ABRIR("test.txt", "w")\` |
| \`ESCRIBIR_LINEA()\` | Escribe texto en un archivo | \`ESCRIBIR_LINEA(f, "texto")\` |
| \`LEER_LINEA()\` | Lee una línea | \`linea = LEER_LINEA(f)\` |
| \`CERRAR()\` | Cierra el archivo | \`CERRAR(f)\` |
| \`FIN_ARCHIVO()\` | Indica si se alcanzó el final | \`SI (!FIN_ARCHIVO(f)) ...\` |
| \`ARCHIVO_EXISTE()\` | Verifica existencia | \`existe = ARCHIVO_EXISTE("test.txt")\` |
| \`BORRAR()\` | Elimina un archivo | \`BORRAR("test.txt")\` |
| \`LISTAR_ARCHIVOS()\` | Lista archivos por patrón | \`cant = LISTAR_ARCHIVOS("*.dat", archivos)\` |

## Ejemplo básico de escritura

\`\`\`blox
ARCHIVO f
LOGICO ok

f = ABRIR("salida.txt", "w")

SI (f == -1) ENTONCES
    ERROR("No se pudo abrir el archivo.")
FIN_SI

ok = ESCRIBIR_LINEA(f, "Hola desde BLOX")
CERRAR(f)
\`\`\`

## Ejemplo básico de lectura

\`\`\`blox
ARCHIVO f
STRING linea

f = ABRIR("datos.txt", "r")

SI (f == -1) ENTONCES
    ERROR("No se pudo abrir el archivo.")
FIN_SI

MIENTRAS (!FIN_ARCHIVO(f)) HACER
    linea = LEER_LINEA(f)
    IMPRIMIR(linea)
FIN_MIENTRAS

CERRAR(f)
\`\`\`

---

## Una visión práctica

Con **sockets**, BLOX puede conversar con otros programas.  
Con **archivos**, puede conservar y recuperar información.

Juntas, estas dos capacidades convierten al lenguaje en una herramienta mucho más abierta al entorno real:

- procesa datos
- guarda resultados
- intercambia mensajes
- se conecta a otros sistemas
- automatiza tareas concretas

En otras palabras, BLOX no solo calcula: también **lee, escribe y se comunica**.
`,
  },
  'conditionals': {
    title: 'Estructuras Condicionales',
    content: `# Estructuras Condicionales

Las estructuras condicionales permiten que un programa tome decisiones.

Gracias a ellas, BLOX puede:

- ejecutar una acción cuando se cumple una condición
- elegir entre dos caminos posibles
- seleccionar un caso entre varias alternativas
- reaccionar de manera distinta según los datos de entrada

En otras palabras, las condicionales introducen lógica de decisión dentro del flujo del programa.

## \`SI ... ENTONCES ... SINO ... FIN_SI\`

La estructura \`SI\` es la forma básica de evaluación condicional en BLOX.

Se usa cuando queremos ejecutar un bloque solo si una condición resulta verdadera.

## Sintaxis general

\`\`\`blox
SI (condicion) ENTONCES
    // instrucciones si la condicion es verdadera
SINO
    // instrucciones si la condicion es falsa
FIN_SI
\`\`\`

La parte \`SINO\` es opcional.

## Ejemplo simple

\`\`\`blox
FUNCION PRINCIPAL
INICIO

    NUMERICO i

    i = 4

    SI (i < 10) ENTONCES
        i = 10
    SINO
        i = 0
    FIN_SI

    IMPRIMIR(i)

FINAL
\`\`\`

En este ejemplo:

- si \`i\` es menor que \`10\`, se le asigna \`10\`
- en caso contrario, se le asigna \`0\`

## \`SI\` sin \`SINO\`

También puede usarse solo para ejecutar una acción cuando la condición es verdadera.

\`\`\`blox
SI (edad >= 18) ENTONCES
    IMPRIMIR("Mayor de edad")
FIN_SI
\`\`\`

## Condiciones compuestas

Las condiciones pueden combinar comparaciones y operadores lógicos.

\`\`\`blox
SI (nota >= 60 & asistencia >= 75) ENTONCES
    IMPRIMIR("Aprobado")
SINO
    IMPRIMIR("No aprobado")
FIN_SI
\`\`\`

## \`SIEMPRE ... QUE ... OTRO ... FIN_SIEMPRE\`

La estructura \`SIEMPRE\` permite evaluar **varios casos en secuencia**, de manera parecida a una selección múltiple.

Su forma general es:

\`\`\`blox
SIEMPRE
    QUE (condicion_1)
        // bloque 1
    QUE (condicion_2)
        // bloque 2
    QUE (condicion_3)
        // bloque 3
    OTRO
        // bloque por defecto
FIN_SIEMPRE
\`\`\`

Cada cláusula \`QUE (...)\` representa un caso posible.  
La cláusula \`OTRO\` actúa como caso por defecto cuando no se cumple ninguna de las condiciones anteriores.

## Ejemplo: cantidad de días de un mes

\`\`\`blox
FUNCION PRINCIPAL
INICIO
    NUMERICO mes, dias

    mes = 2

    SIEMPRE
        QUE (mes == 1 | mes == 3 | mes == 5 | mes == 7 | mes == 8 | mes == 10 | mes == 12)
            IMPRIMIR("Mes de 31 dias")
            dias = 31

        QUE (mes == 4 | mes == 6 | mes == 9 | mes == 11)
            IMPRIMIR("Mes de 30 dias")
            dias = 30

        QUE (mes == 2)
            IMPRIMIR("Mes de 28 o 29 dias")
            dias = 28

        OTRO
            IMPRIMIR("Mes invalido")
            dias = -1
    FIN_SIEMPRE

    IMPRIMIR("\\nDias asignados: ", dias)
FINAL
\`\`\`

Aquí, BLOX evalúa varias posibilidades para determinar la cantidad de días del mes.

## Ejemplo: comparar dos strings

\`\`\`blox
FUNCION PRINCIPAL
INICIO
    NUMERICO es
    STRING str1, str2

    str1 = "Alfa"
    str2 = "Beta"

    es = COMPARAR(str1, str2)

    SIEMPRE
        QUE (es == 0)
            IMPRIMIR("Son iguales")

        QUE (es == 1)
            IMPRIMIR("str1 es mayor")

        QUE (es == -1)
            IMPRIMIR("str1 es menor")

        OTRO
            ERROR("Resultado no esperado")
    FIN_SIEMPRE

FINAL
\`\`\`

Este patrón resulta útil cuando una función puede devolver varios valores discretos y queremos reaccionar de forma distinta ante cada uno.

## Diferencia entre \`SI\` y \`SIEMPRE\`

### \`SI\`

Se usa cuando hay una sola condición principal:

\`\`\`blox
SI (x > 0) ENTONCES
    IMPRIMIR("Positivo")
FIN_SI
\`\`\`

### \`SIEMPRE\`

Se usa cuando hay varios casos alternativos:

\`\`\`blox
SIEMPRE
    QUE (x < 0)
        IMPRIMIR("Negativo")
    QUE (x == 0)
        IMPRIMIR("Cero")
    OTRO
        IMPRIMIR("Positivo")
FIN_SIEMPRE
\`\`\`

## Cuándo conviene usar cada una

- Usa \`SI\` para decisiones simples.
- Usa \`SI ... SINO\` cuando solo hay dos caminos principales.
- Usa \`SIEMPRE ... QUE ... OTRO\` cuando hay varios casos mutuamente excluyentes o cuando quieres escribir una selección múltiple de forma clara.

## Buenas prácticas

- Mantén las condiciones legibles.
- Si una condición es muy larga, considera dividirla o calcularla antes en una variable lógica.
- Usa \`OTRO\` cuando quieras dejar un caso por defecto explícito.
- Prefiere \`SIEMPRE\` frente a cadenas largas de decisiones cuando hay varios casos bien definidos.

## Errores frecuentes

### 1. Olvidar el cierre del bloque

Cada estructura debe cerrarse correctamente:

- \`SI ... FIN_SI\`
- \`SIEMPRE ... FIN_SIEMPRE\`

### 2. Usar \`SINO\` donde corresponde \`OTRO\`

Dentro de \`SIEMPRE\`, el bloque por defecto es:

\`\`\`blox
OTRO
\`\`\`

no \`SINO\`.

### 3. Hacer condiciones difíciles de leer

Esto:

\`\`\`blox
SI (a > 0 & b > 0 & c > 0 & d > 0 & e > 0) ENTONCES
\`\`\`

puede ser correcto, pero no siempre es la forma más clara.  
A veces conviene extraer parte de la lógica a variables intermedias.

## Resumen

En BLOX, las estructuras condicionales principales son:

- \`SI ... ENTONCES ... FIN_SI\`
- \`SI ... ENTONCES ... SINO ... FIN_SI\`
- \`SIEMPRE ... QUE ... OTRO ... FIN_SIEMPRE\`

Con ellas, el lenguaje puede expresar:

- decisiones simples
- alternativas dobles
- selección entre múltiples casos

Son una parte esencial del control de flujo y aparecen en prácticamente cualquier programa no trivial.
`,
  },
  'loops': {
    title: 'Bucles',
    content: `# Bucles

Los bucles, o ciclos, permiten repetir instrucciones dentro de un programa.

Son esenciales cuando necesitamos:

- recorrer datos
- repetir un cálculo
- procesar colecciones
- iterar hasta que ocurra cierta condición
- automatizar tareas repetitivas

En BLOX, las estructuras de repetición principales son:

- \`MIENTRAS ... HACER ... FIN_MIENTRAS\`
- \`HACER ... MIENTRAS_QUE\`
- \`PARA ... HASTA ... PASO ... HACER ... FIN_PARA\`

Cada una responde a una necesidad ligeramente distinta.

## MIENTRAS ... HACER ... FIN_MIENTRAS

La estructura \`MIENTRAS\` ejecuta un bloque mientras una condición sea verdadera.

La condición se evalúa **antes** de entrar en cada iteración.

Por eso:

- si la condición es falsa desde el comienzo, el bloque no se ejecuta ni una sola vez
- si la condición sigue siendo verdadera, el bucle continúa

## Sintaxis general

\`\`\`blox
MIENTRAS (condicion) HACER
    // instrucciones
FIN_MIENTRAS
\`\`\`

## Ejemplo

\`\`\`blox
FUNCION PRINCIPAL
INICIO

    NUMERICO i

    i = 0

    MIENTRAS (i < 100) HACER
        IMPRIMIR(i)
        i = i + 1
    FIN_MIENTRAS

FINAL
\`\`\`

Este programa imprime los números del \`0\` al \`99\`.

## Cuándo conviene usar MIENTRAS

Usa \`MIENTRAS\` cuando:

- no sabes de antemano cuántas veces se repetirá el bloque
- la repetición depende de una condición dinámica
- puede ocurrir que el bloque no deba ejecutarse nunca

---

## HACER ... MIENTRAS_QUE

La estructura \`HACER ... MIENTRAS_QUE\` garantiza al menos una ejecución del bloque.

La condición se evalúa **después** de ejecutar el cuerpo del ciclo.

## Sintaxis general

\`\`\`blox
HACER
    // instrucciones
MIENTRAS_QUE (condicion)
\`\`\`

## Ejemplo

\`\`\`blox
FUNCION PRINCIPAL
INICIO

    NUMERICO i

    i = 0

    HACER
        IMPRIMIR(i)
        i = i + 1
    MIENTRAS_QUE (i < 5)

FINAL
\`\`\`

Este programa imprime:

- \`0\`
- \`1\`
- \`2\`
- \`3\`
- \`4\`

## Cuándo conviene usar HACER ... MIENTRAS_QUE

Es útil cuando el bloque debe ejecutarse al menos una vez, por ejemplo:

- lectura inicial de datos
- menús interactivos
- validaciones iterativas
- procesos donde primero se actúa y luego se verifica si se continúa

---

## PARA ... HASTA ... PASO ... HACER ... FIN_PARA

La estructura \`PARA\` se usa cuando queremos repetir un bloque un número controlado de veces.

Es ideal cuando existe una variable de control que avanza desde un valor inicial hasta un límite.

## Sintaxis general

\`\`\`blox
PARA i = inicio HASTA fin HACER
    // instrucciones
FIN_PARA
\`\`\`

También puede usarse con \`PASO\`:

\`\`\`blox
PARA i = inicio HASTA fin PASO salto HACER
    // instrucciones
FIN_PARA
\`\`\`

## Ejemplo simple

\`\`\`blox
FUNCION PRINCIPAL
INICIO

    NUMERICO i

    PARA i = 1 HASTA 5 HACER
        IMPRIMIR(i)
    FIN_PARA

FINAL
\`\`\`

## Ejemplo con paso

\`\`\`blox
FUNCION PRINCIPAL
INICIO

    NUMERICO i

    PARA i = 0 HASTA 10 PASO 2 HACER
        IMPRIMIR(i)
    FIN_PARA

FINAL
\`\`\`

Este ejemplo imprime:

- \`0\`
- \`2\`
- \`4\`
- \`6\`
- \`8\`
- \`10\`

## Cuándo conviene usar PARA

Usa \`PARA\` cuando:

- el número de iteraciones es conocido
- quieres recorrer un intervalo
- necesitas una variable de control explícita
- estás recorriendo índices o dimensiones

---

## SALIR

La instrucción \`SALIR\` permite abandonar el bucle actual antes de que la condición natural de terminación se cumpla.

## Ejemplo

\`\`\`blox
NUMERICO i

PARA i = 0 HASTA 10 HACER
    SI (i == 5) ENTONCES
        SALIR
    FIN_SI

    IMPRIMIR(i)
FIN_PARA
\`\`\`

Este bucle termina cuando \`i\` llega a \`5\`.

## CONTINUAR

La instrucción \`CONTINUAR\` salta directamente a la siguiente iteración del bucle.

## Ejemplo

\`\`\`blox
NUMERICO i

PARA i = 0 HASTA 5 HACER
    SI (i == 3) ENTONCES
        CONTINUAR
    FIN_SI

    IMPRIMIR(i)
FIN_PARA
\`\`\`

Aquí se omite la impresión del valor \`3\`.

---

## Comparación rápida entre los tres tipos de bucle

| Estructura | Cuándo evalúa la condición | ¿Puede no ejecutarse nunca? | Caso típico |
|---|---|---|---|
| \`MIENTRAS\` | Antes de cada iteración | Sí | Repetición condicionada |
| \`HACER ... MIENTRAS_QUE\` | Después de ejecutar | No | Al menos una ejecución |
| \`PARA\` | Según rango y paso | Depende del rango | Repetición controlada |

## Buenas prácticas

- Asegúrate de que la condición del bucle pueda dejar de cumplirse.
- Actualiza correctamente la variable de control.
- Usa \`PARA\` cuando el número de repeticiones esté claro.
- Usa \`MIENTRAS\` cuando la condición sea la verdadera guía del proceso.
- Usa \`HACER ... MIENTRAS_QUE\` cuando el cuerpo deba ejecutarse al menos una vez.
- Usa \`SALIR\` y \`CONTINUAR\` con moderación y solo cuando hagan el flujo más claro.

## Errores frecuentes

### 1. Crear un bucle infinito sin querer

\`\`\`blox
MIENTRAS (i < 10) HACER
    IMPRIMIR(i)
FIN_MIENTRAS
\`\`\`

Si \`i\` nunca cambia, la condición seguirá siendo verdadera indefinidamente.

### 2. Elegir el tipo de bucle equivocado

Si el bloque debe ejecutarse al menos una vez, \`MIENTRAS\` puede no ser la mejor opción.  
En ese caso suele convenir \`HACER ... MIENTRAS_QUE\`.

### 3. Usar mal los límites del PARA

El comportamiento del bucle depende del valor inicial, el límite y el paso.  
Conviene revisar bien esos tres elementos antes de asumir cuántas iteraciones habrá.

### 4. Abusar de SALIR

\`SALIR\` es útil, pero si aparece demasiadas veces dentro del mismo bloque, el flujo puede volverse difícil de leer.

## Resumen

En BLOX, los bucles principales son:

- \`MIENTRAS\`
- \`HACER ... MIENTRAS_QUE\`
- \`PARA\`

Con ellos puedes expresar:

- repeticiones condicionadas
- ciclos con ejecución mínima garantizada
- recorridos controlados por contador

Son una parte esencial del control de flujo y aparecen en casi todos los programas no triviales.
`,
  },
  'conditional-assignment': {
    title: 'Asignación Condicional',
    content: `# Asignacion Condicional Avanzada

La asignacion condicional avanzada permite escribir decisiones y construcciones de vectores en una forma compacta y expresiva.

En BLOX existen dos familias principales:

- asignacion condicional escalar
- construccion vectorial con \`MIENTRAS ... VALOR ...\`

Ambas comparten la palabra clave \`VALOR\`, pero no tienen exactamente la misma semantica.

---

## 1. Asignacion condicional escalar

Se usa para asignar un valor a una variable segun una condicion.

### Sintaxis

\`\`\`blox
variable = SI (condicion) VALOR expr
variable = SI (condicion) VALOR expr SINO expr2
\`\`\`

### Semantica

#### Forma completa

\`\`\`blox
variable = SI (condicion) VALOR expr SINO expr2
\`\`\`

Significa:

- si la condicion es verdadera, se asigna \`expr\`
- si la condicion es falsa, se asigna \`expr2\`

Es equivalente a:

\`\`\`blox
SI (condicion) ENTONCES
    variable = expr
SINO
    variable = expr2
FIN_SI
\`\`\`

#### Forma abreviada sin \`SINO\`

\`\`\`blox
variable = SI (condicion) VALOR expr
\`\`\`

Significa:

- si la condicion es verdadera, se asigna \`expr\`
- si la condicion es falsa, la variable conserva su valor anterior

Es equivalente a:

\`\`\`blox
SI (condicion) ENTONCES
    variable = expr
FIN_SI
\`\`\`

### Ejemplo con \`NUMERICO\`

\`\`\`blox
FUNCION PRINCIPAL
INICIO

    NUMERICO mayor, c, d

    c = 54
    d = 10

    mayor = SI (c > d) VALOR c SINO d

    IMPRIMIR("\\nmayor = ", mayor)   // Esperado: 54

FINAL
\`\`\`

### Ejemplo sin \`SINO\`

\`\`\`blox
FUNCION maximo(V)
INICIO
    NUMERICO i, dimension, mayor

    dimension = V.dim
    mayor = V[0]

    i = 1
    MIENTRAS (i < dimension) HACER
        mayor = SI (V[i] > mayor) VALOR V[i]
        i = i + 1
    FIN_MIENTRAS

    RETORNAR mayor
FINAL_FUNCION
\`\`\`

En este caso:

- si \`V[i] > mayor\`, \`mayor\` se actualiza
- si no, \`mayor\` conserva su valor anterior

---

## 2. Construccion vectorial con \`MIENTRAS\`

Esta forma permite construir un vector elemento a elemento usando el iterador interno \`k\`.

## Nota importante sobre la clausula \`MIENTRAS\`

En esta construccion vectorial, \`MIENTRAS\` no aparece solo ni recibe una condicion logica arbitraria como en los bucles normales.

Una forma general de esta sintaxis es:

\`\`\`blox
v = MIENTRAS (k < limite) SI (condicion) VALOR expr1 SINO expr2
\`\`\`

donde \`limite\` puede ser:

- un literal numerico
- una variable numerica
- una expresion numerica

Ademas:

- \`k\` es un iterador interno de esta construccion
- no necesita ser declarado
- no puede reemplazarse por otro nombre como \`i\`

y \`condicion\` puede ser:

- una variable del tipo \`LOGICO\`
- cualquier expresion logica

Por ejemplo, esta forma es valida:

\`\`\`blox
v = MIENTRAS (k < limite) VALOR k
\`\`\`

pero esta forma no pertenece a la sintaxis soportada:

\`\`\`blox
v = MIENTRAS (i < limite) VALOR i
\`\`\`

En la implementacion actual, la construccion reconoce especificamente el iterador \`k\`.

Esa clausula no es la unica variante soportada.

Podemos escribirla de varias maneras, por ejemplo:

\`\`\`blox
v = MIENTRAS (k < limite) VALOR expr
v = MIENTRAS (k < limite) SI (condicion) VALOR expr
v = MIENTRAS (k < limite) SI (condicion) VALOR expr1 SINO expr2
\`\`\`

## Semantica de cada parte

- \`MIENTRAS (k < limite)\` define el recorrido del indice \`k\`
- \`VALOR ...\` define el valor que se agrega al vector
- \`SI (condicion)\` es opcional y permite filtrar o elegir entre ramas

## Formas soportadas

\`\`\`blox
vector = MIENTRAS (k < limite) VALOR expr
vector = MIENTRAS (k < limite) SI (condicion) VALOR expr
vector = MIENTRAS (k < limite) SI (condicion) VALOR expr SINO expr2
\`\`\`

## Interpretacion

- sin \`SI\`: mapeo directo
- con \`SI\` y sin \`SINO\`: filtro + proyeccion
- con \`SI\` y \`SINO\`: seleccion completa

### Semantica

#### Mapeo directo

\`\`\`blox
vector = MIENTRAS (k < limite) VALOR expr
\`\`\`

Para cada valor de \`k\`:

- se evalua \`expr\`
- el resultado se agrega al vector

Es una forma compacta de generar un vector completo.

### Ejemplo: \`linspace\`

\`\`\`blox
FUNCION linspace(puntos, x_min, x_max)
INICIO
    SI (puntos < 1) ENTONCES
        VECTOR v[1]
        v[0] = x_min
        RETORNAR v
    FIN_SI

    NUMERICO dx, aux

    aux = SI (puntos > 1) VALOR puntos SINO 1
    dx = (x_max - x_min) / aux

    VECTOR v[puntos]
    v = MIENTRAS (k < puntos) VALOR x_min + k*dx

    RETORNAR v
FINAL_FUNCION
\`\`\`

#### Filtro + proyeccion

\`\`\`blox
vector = MIENTRAS (k < limite) SI (condicion) VALOR expr
\`\`\`

Para cada valor de \`k\`:

- si la condicion es verdadera, se agrega \`expr\`
- si la condicion es falsa, no se agrega ningun elemento

El vector resultado puede tener menos elementos que \`limite\`.

### Ejemplo

\`\`\`blox
FUNCION PRINCIPAL
INICIO

    VECTOR v

    v = MIENTRAS (k < 6) SI (k % 2 == 0) VALOR k

    DEPURAR(v)   // Esperado: [0, 2, 4]

FINAL
\`\`\`

#### Seleccion completa

\`\`\`blox
vector = MIENTRAS (k < limite) SI (condicion) VALOR expr SINO expr2
\`\`\`

Para cada valor de \`k\`:

- si la condicion es verdadera, se agrega \`expr\`
- si la condicion es falsa, se agrega \`expr2\`

En este caso, el vector final normalmente tendra \`limite\` elementos.

### Ejemplo

\`\`\`blox
FUNCION PRINCIPAL
INICIO

    VECTOR v[15]

    v = MIENTRAS (k < v.dim) SI (k % 5 == 0) VALOR pi/RAIZ(2) SINO 0

    vectores.imprimir(v)

FINAL
\`\`\`

Este ejemplo llena el vector con:

- \`pi/RAIZ(2)\` en los indices multiplo de 5
- \`0\` en las demas posiciones

---

## 3. Diferencia conceptual entre escalares y vectores

Aunque ambas sintaxis usan \`SI (...) VALOR ...\`, no hacen lo mismo.

### En escalares

\`\`\`blox
x = SI (cond) VALOR expr
\`\`\`

Aqui ya existe un destino previo: la variable \`x\`.

Si la condicion es verdadera:

- se asigna \`expr\`

Si la condicion es falsa:

- \`x\` conserva su valor anterior

Es decir, la forma escalar sin \`SINO\` no crea un valor nuevo para la rama falsa.
Lo que hace es preservar el estado que la variable ya tenia antes de la asignacion.

### En vectores

\`\`\`blox
v = MIENTRAS (...) SI (cond) VALOR expr
\`\`\`

Aqui no existe un valor previo por posicion que haya que conservar.
El vector se va construyendo durante el recorrido.

Si la condicion es verdadera:

- se agrega \`expr\` al vector resultado

Si la condicion es falsa:

- no se agrega ningun elemento

Es decir, la forma vectorial sin \`SINO\` no preserva un valor anterior.
Simplemente omite esa posicion del resultado.

## Diferencia clave

- en escalares, la rama falsa preserva el contenido previo de una variable ya existente
- en vectores, la rama falsa reduce la salida porque no agrega un nuevo elemento

Por eso las dos formas pueden parecer parecidas en la sintaxis, pero no tienen la misma semantica.
La diferencia es intencional y hace que ambas resulten utiles.

---

## 4. Cuando conviene usar cada forma

### Usa asignacion condicional escalar cuando:

- quieres decidir un valor entre dos alternativas
- quieres actualizar una variable solo si una condicion se cumple
- quieres escribir codigo mas compacto sin perder claridad

### Usa construccion vectorial con \`MIENTRAS\` cuando:

- quieres generar un vector a partir de una formula
- quieres filtrar elementos mientras construyes el resultado
- quieres evitar bucles manuales para tareas de mapeo o seleccion

---

## 5. Buenas practicas

- Usa la forma sin \`SINO\` solo cuando la semantica sea evidente.
- Si la condicion o la expresion son muy largas, considera partirlas en variables auxiliares.
- En vectores, recuerda que la forma sin \`SINO\` puede reducir el tamano final del resultado.
- Si necesitas conservar exactamente la misma cantidad de elementos, usa la forma con \`SINO\`.

---

## 6. Resumen rapido

### Escalares

\`\`\`blox
var = SI (cond) VALOR expr
var = SI (cond) VALOR expr SINO expr2
\`\`\`

### Vectores

\`\`\`blox
v = MIENTRAS (k < limite) VALOR expr
v = MIENTRAS (k < limite) SI (cond) VALOR expr
v = MIENTRAS (k < limite) SI (cond) VALOR expr SINO expr2
\`\`\`

### Idea clave

- en escalares sin \`SINO\`, se conserva el valor anterior
- en vectores sin \`SINO\`, se filtran los elementos
`,
  },
  'databases': {
    title: 'Bases de Datos',
    content: `# Bases de Datos

BLOX incorpora soporte para **bases de datos SQLite** mediante el tipo \`SQLITE\` y la API \`sqlite.api\`.

Esto permite:

- abrir o crear una base de datos
- ejecutar sentencias SQL
- consultar datos y recibirlos como \`TABLA\`
- persistir tablas planas de BLOX
- recuperar esas tablas más adelante

En otras palabras, BLOX ya no depende solo de archivos de texto o JSON para conservar información: también puede trabajar con una base de datos real.

## Tipo de dato \`SQLITE\`

Una variable de tipo \`SQLITE\` representa una conexión abierta a una base de datos SQLite.

\`\`\`blox
SQLITE db

db = sqlite.abrir("datos.db")
\`\`\`

Ese valor no contiene los datos directamente.  
Contiene un **handle de conexión** que luego se usa para ejecutar sentencias o traer resultados.

## API básica

La API principal actual es:

- \`sqlite.abrir(archivo)\`
- \`sqlite.cerrar(db)\`
- \`sqlite.ejecutar(db, sql)\`
- \`sqlite.consulta(db, sql)\`
- \`sqlite.importar(db, nombre_tabla, tabla)\`
- \`sqlite.exportar(db, sql)\`

## Abrir y cerrar una base

\`\`\`blox
INCLUIR "sqlite.api"

FUNCION PRINCIPAL
INICIO

    SQLITE db

    db = sqlite.abrir("mi_base.db")

    // ... trabajo con la base ...

    sqlite.cerrar(db)

FINAL
\`\`\`

### Qué hace \`sqlite.abrir()\`

- si el archivo existe, lo abre
- si no existe, lo crea
- retorna un valor de tipo \`SQLITE\`

### Qué hace \`sqlite.cerrar()\`

- cierra la conexión
- libera recursos internos

---

## Ejecutar SQL sin resultado tabular

Usa \`sqlite.ejecutar()\` para sentencias como:

- \`CREATE TABLE\`
- \`INSERT\`
- \`UPDATE\`
- \`DELETE\`
- \`DROP\`

\`\`\`blox
INCLUIR "sqlite.api"

FUNCION PRINCIPAL
INICIO

    SQLITE db

    db = sqlite.abrir("personas.db")

    sqlite.ejecutar(db, "CREATE TABLE IF NOT EXISTS personas (id INTEGER, nombre TEXT);")
    sqlite.ejecutar(db, "INSERT INTO personas VALUES (1, 'Ana');")
    sqlite.ejecutar(db, "INSERT INTO personas VALUES (2, 'Luis');")

    sqlite.cerrar(db)

FINAL
\`\`\`

---

## Consultar datos con \`sqlite.consulta()\`

Cuando una sentencia SQL devuelve filas, BLOX las recibe como una \`TABLA\`.

\`\`\`blox
INCLUIR "sqlite.api"
INCLUIR "tablas.api"

FUNCION PRINCIPAL
INICIO

    SQLITE db
    TABLA t

    db = sqlite.abrir("personas.db")

    t = sqlite.consulta(db, "SELECT id, nombre FROM personas ORDER BY id;")

    tablas.imprimir(t)

    sqlite.cerrar(db)

FINAL
\`\`\`

### Resultado

La consulta retorna una \`TABLA\` BLOX con tipado por celda.

Ejemplo conceptual:

\`\`\`blox
{
    id = 1,
    nombre = "Ana"
}
\`\`\`

---

## Persistir tablas con \`sqlite.importar()\`

Si ya tienes una \`TABLA\` en memoria, puedes enviarla a SQLite.

\`\`\`blox
INCLUIR "sqlite.api"

FUNCION PRINCIPAL
INICIO

    SQLITE db
    TABLA t

    t = {id = 1, nombre = "Ana", saldo = 10.5}
    t = {id = 2, nombre = "Luis", saldo = 7.0, nota = "ok"}

    db = sqlite.abrir("personas.db")

    sqlite.importar(db, "personas", t)

    sqlite.cerrar(db)

FINAL
\`\`\`

### Comportamiento actual

- recrea la tabla destino
- soporta campos escalares:
  - \`NUMERICO\`
  - \`LOGICO\`
  - \`STRING\`
  - \`VACIO\`
- los campos faltantes se guardan como \`NULL\`

Esto la vuelve especialmente útil para:

- persistir resultados de programas
- guardar catálogos o listados
- conservar datos intermedios
- mover tablas entre ejecuciones

---

## Recuperar tablas con \`sqlite.exportar()\`

\`sqlite.exportar()\` es una forma semántica de decir:

- "sacar datos desde SQLite"
- "obtenerlos nuevamente como una \`TABLA\` BLOX"

\`\`\`blox
INCLUIR "sqlite.api"
INCLUIR "tablas.api"

FUNCION PRINCIPAL
INICIO

    SQLITE db
    TABLA out

    db = sqlite.abrir("personas.db")

    out = sqlite.exportar(db, "SELECT id, nombre, saldo, nota FROM personas ORDER BY id;")

    tablas.imprimir(out)

    sqlite.cerrar(db)

FINAL
\`\`\`

---

## Relación con \`TABLA\`

SQLite y \`TABLA\` se complementan muy bien en BLOX:

- \`TABLA\` sirve para trabajar con los datos en memoria
- \`SQLITE\` sirve para persistirlos y consultarlos

Esto permite flujos como:

- archivo \`json/dat\` -> \`TABLA\`
- \`TABLA\` -> SQLite
- SQLite -> \`TABLA\`
- \`TABLA\` -> JSON

## Límite actual importante

La versión actual de \`sqlite.importar/exportar\` está pensada para **tablas planas**.

Eso significa:

- funciona bien con campos escalares
- no está pensada para normalizar automáticamente subtablas anidadas

Si los datos son jerárquicos o muy anidados, la estrategia correcta es:

- diseñar varias tablas relacionadas
- o generar esa base externamente y luego consultarla desde BLOX

---

## \`NULL\`

Cuando SQLite devuelve un valor \`NULL\`, BLOX hoy lo representa como un valor nulo interno y lo imprime como:

\`\`\`blox
NULL
\`\`\`

Esto permite distinguirlo de:

- \`0\`
- \`""\`
- \`FALSO\`

---

## Caso de uso típico

Una secuencia muy natural en BLOX es esta:

1. cargar datos externos a una \`TABLA\`
2. persistirlos con \`sqlite.importar()\`
3. hacer consultas SQL
4. recuperar resultados como \`TABLA\`
5. imprimir, filtrar, graficar o exportar

## Un ejemplo resumido

\`\`\`blox
INCLUIR "sqlite.api"
INCLUIR "tablas.api"

FUNCION PRINCIPAL
INICIO

    SQLITE db
    TABLA t, out

    t = {id = 1, nombre = "Ana", saldo = 10.5}
    t = {id = 2, nombre = "Luis", saldo = 7.0}

    db = sqlite.abrir("demo.db")

    sqlite.importar(db, "personas", t)

    out = sqlite.exportar(db, "SELECT nombre, saldo FROM personas ORDER BY nombre;")

    tablas.imprimir(out)

    sqlite.cerrar(db)

FINAL
\`\`\`

---

## Conclusión

Con SQLite, BLOX da un paso importante hacia programas con **persistencia real**.

Ya no se trata solo de calcular o procesar datos en memoria.  
Ahora también puede:

- guardar
- recuperar
- consultar
- reorganizar
- reutilizar información entre ejecuciones

Esto convierte a \`TABLA\` y \`SQLITE\` en una combinación muy poderosa para aplicaciones prácticas.
`,
  },
  'user-functions': {
    title: 'Funciones de Usuario',
    content: `# Funciones de Usuario

Aprender a usar funciones es como tener tu propia caja de herramientas: te permiten reutilizar código, organizar tus programas y resolver problemas complejos dividiéndolos en partes pequeñas.

## Definición y Sintaxis

Una función es un bloque de código que hace una tarea específica y que puedes llamar todas las veces que quieras.

## Tipos de Funciones en BLOX

1. **Funciones internas** - Provistas por el lenguaje
2. **Funciones de usuario** - Las que tú creas
3. **Funciones API** - Librerías externas

## Parámetros

Los parámetros son los datos de entrada que recibe la función.

- **Paso por valor:** números, strings simples (la función recibe una copia)
- **Paso por referencia:** vectores, matrices, tablas, archivos, sockets (la función puede modificar el original)

BLOX decide automáticamente cuál usar.

## Estructura

Las funciones se escriben al final del programa. Solo su prototipo (nombre y argumentos) va arriba del FUNCION PRINCIPAL.`,
  },
  'internal-api': {
    title: 'Funciones Internas y API',
    content: `# Funciones Internas y API

Además de las funciones que escribes tú, BLOX trae una potente colección de funciones internas y librerías API listas para usar.

## Funciones Internas

Las funciones internas están a tu disposición siempre. Son parte del núcleo del lenguaje.

### Ejemplos comunes:

- **Entrada/Salida:** \`IMPRIMIR()\`, \`LEER()\`
- **Matemáticas:** \`ENTERO()\`, \`RAIZ()\`, \`ALEATORIO()\`
- **Strings:** \`LONGITUD()\`, \`CONCATENAR()\`, \`SUBSTR()\`
- **Archivos:** \`ABRIR()\`, \`ESCRIBIR_LINEA()\`, \`ARCHIVO_EXISTE()\`
- **Sockets:** \`CONECTAR()\`, \`ENVIAR()\`, \`RECIBIR()\`
- **Tablas:** \`AGREGAR()\`, \`ELIMINAR()\`, \`CLAVES()\`

## Funciones API

Las funciones API vienen en archivos separados con extensión \`.api\`:

- **archivos.api** - Operaciones avanzadas con archivos
- **estadisticas.api** - Funciones estadísticas
- **fechas.api** - Manejo de fechas
- **strings.api** - Manipulación avanzada de cadenas
- **tablas.api** - Operaciones con tablas
- **vectores.api** - Algoritmos con vectores
- **matrices.api** - Operaciones con matrices

### Uso de API

Para usar una API, primero debes incluirla con \`INCLUIR\`:`,
  },
  'reference': {
    title: 'Referencia Rápida de Funciones',
    content: `# Referencia Rápida de Funciones

## Funciones Internas

### Numéricas y Lógicas

- \`ALEATORIO(límite)\` - Número aleatorio entre 0 y límite-1
- \`ENTERO(n)\` - Trunca decimal
- \`REDONDEO(n)\` - Redondea a entero
- \`RAIZ(x)\` - Raíz cuadrada

### Strings

- \`IGUAL(a, b)\` - Compara si a == b
- \`COMPARAR(a, b)\` - Devuelve 0 si iguales, <0 si a<b, >0 si a>b
- \`CONCATENAR(a, b)\` - Une cadenas
- \`ENCONTRAR(subtexto, texto)\` - Posición de subtexto (0 si no está)
- \`SUBSTR(str, ini, len)\` - Substring
- \`TRIM(str)\` - Elimina espacios
- \`MAYUSCULA(str)\`, \`MINUSCULA(str)\` - Conversión de caso
- \`REEMPLAZAR(str, viejo, nuevo)\` - Reemplaza texto
- \`LONGITUD(str)\` - Cantidad de caracteres

### Entrada/Salida

- \`LEER(var)\` - Lee de teclado
- \`IMPRIMIR(a, b, ...)\` - Imprime en consola (máx 10 argumentos)
- \`DIVIDIR(str, delim, partes)\` - Divide en vector por delimitador
- \`UNIR(a, b, c, ...)\` - Une cadenas/números (máx 10 argumentos)

### Archivos

- \`ABRIR(nombre, modo)\` - Abre archivo ("r", "w", "a")
- \`CERRAR(f)\` - Cierra archivo
- \`LEER_LINEA(f)\` - Lee línea
- \`ESCRIBIR_LINEA(f, str)\` - Escribe línea
- \`LEER_TODO(f)\` - Lee todo el contenido
- \`BORRAR(nombre)\` - Borra archivo
- \`ARCHIVO_EXISTE(nombre)\` - Verifica existencia
- \`FIN_ARCHIVO(f)\` - Indica si llegó al final
- \`LISTAR_ARCHIVOS(patrón, vector)\` - Lista archivos

### Sockets

- \`CONECTAR(s)\` - Conecta socket
- \`ENVIAR(s, datos)\` - Envía datos
- \`RECIBIR(s)\` - Recibe datos
- \`DESCONECTAR(s)\` - Cierra conexión
- \`ESCUCHAR(s)\` - Modo servidor
- \`ACEPTAR(s)\` - Acepta conexión entrante

### Tablas

- \`AGREGAR(tabla, registro)\` - Agrega registro
- \`ELIMINAR(registro)\` - Elimina registro
- \`ES_CAMPO(registro, campo)\` - Verifica si existe campo
- \`CLAVES(registro)\` - Vector con nombres de campos
- \`TIPO_DATO(registro, clave)\` - Tipo del campo
- \`JSON_A_TABLA(json_str, tabla)\` - Convierte JSON a tabla

## Funciones API Principales

### fechas.api

- \`fechas.crear(d, m, a)\` - Crea fecha dd/mm/aaaa
- \`fechas.es_bisiesto(anio)\` - Verifica año bisiesto
- \`fechas.es_valida(d, m, a)\` - Valida fecha
- \`fechas.sumar_dias(fecha, dias)\` - Suma días
- \`fechas.diferencia_dias(fecha1, fecha2)\` - Diferencia entre fechas

### tablas.api

- \`tablas.filtrar(tabla, campo, valor)\` - Filtra registros
- \`tablas.buscar(tabla, campo, valor)\` - Busca registro
- \`tablas.ordenar_quick(tabla, campo)\` - Ordena tabla
- \`tablas.exportar_tabla_csv(tabla, archivo)\` - Exporta a CSV
- \`tablas.importar_csv_tabla(archivo)\` - Importa desde CSV
- \`tablas.imprimir(tabla, 1)\` - Imprime tabla formateada

### vectores.api

- \`vectores.copiar(origen, destino)\` - Copia vector
- \`vectores.invertir(V)\` - Invierte orden
- \`vectores.buscar_secuencial(Vect, buscado)\` - Búsqueda lineal
- \`vectores.buscar_binario(A, buscado)\` - Búsqueda binaria
- \`vectores.ordenar_quick(Vector)\` - QuickSort
- \`vectores.carga_aleatoria(Vector, limite)\` - Carga aleatoria

### matrices.api

- \`matrices.suma(M)\` - Suma todos los elementos
- \`matrices.promedio(M)\` - Promedio de elementos
- \`matrices.maximo(M)\`, \`matrices.minimo(M)\` - Máximo/mínimo
- \`matrices.imprimir(M)\` - Imprime matriz formateada
- \`matrices.diagonal(M)\` - Extrae diagonal

### strings.api

- \`strings.es_numerico(s)\` - Verifica si es número
- \`strings.es_alfa(s)\` - Verifica si es alfabético
- \`strings.dividir_texto(s, vector)\` - Divide en palabras
- \`strings.contar_ocurrencias(texto, sub)\` - Cuenta apariciones
- \`strings.reemplazar_todos(texto, sub, nuevo_sub)\` - Reemplaza todas

Para más detalles, consulta el manual completo del usuario.`,
  },

  // Funciones internas se cargan dinámicamente desde JSON
  ...generateInternalsDocsContent(),
  
  // APIs se cargan dinámicamente desde los JSON
  ...generateApiDocsContent()
};